import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, TransitionGroup as _TransitionGroup, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, vShow as _vShow, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1abb3057")

_pushScopeId("data-v-1abb3057")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = { class: "col-sm-6" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "breadcrumb-wrap mt-1 mb-2" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb mb-0" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home to-upper" }, null, -1)
const _hoisted_10 = { class: "col-sm-6" }
const _hoisted_11 = { class: "inline-items text-sm-right" }
const _hoisted_12 = { class: "file-actions position-relative ml-2 mt-1" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_15 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  src: "img/icons/file-view.svg",
  alt: "",
  class: "mr-2 align-middle"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("img", {
  src: "img/icons/eye.svg",
  alt: "",
  class: "mr-2 align-middle"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("img", {
  src: "img/icons/pin.svg",
  alt: "",
  class: "mr-2 align-middle"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" Unpin project")
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: "img/icons/pin.svg",
  alt: "",
  class: "mr-2 align-middle"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" Pin project")
const _hoisted_22 = { class: "card p-0" }
const _hoisted_23 = { class: "bordered-tab-wrap" }
const _hoisted_24 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_25 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments mr-1" }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" Chat")
const _hoisted_28 = {
  key: 0,
  class: "nav-item",
  role: "presentation"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("i", { class: "fa fa-sitemap mr-1" }, null, -1)
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Workflow")
const _hoisted_31 = { class: "tab-content" }
const _hoisted_32 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_34 = { class: "d-flex justify-content-between" }
const _hoisted_35 = { class: "left-col-wrap p-2 flex-grow-1 h-100 bg-white" }
const _hoisted_36 = { class: "row align-items-center" }
const _hoisted_37 = { class: "col-sm-4" }
const _hoisted_38 = { class: "form-group mb-2 mb-sm-0" }
const _hoisted_39 = { class: "col-sm-2" }
const _hoisted_40 = /*#__PURE__*/_createVNode("i", { class: "fa fa-redo" }, null, -1)
const _hoisted_41 = { class: "col-sm-6" }
const _hoisted_42 = { class: "inline-items text-sm-right align-middle" }
const _hoisted_43 = {
  class: "form-group control-with-icon mb-0 float-sm-right",
  id: "projectStatus"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("div", { class: "control-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-check" })
], -1)
const _hoisted_45 = { value: "active" }
const _hoisted_46 = { value: "closed" }
const _hoisted_47 = { value: "hide" }
const _hoisted_48 = { key: 0 }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_50 = { class: "collapsible-container" }
const _hoisted_51 = /*#__PURE__*/_createVNode("i", { class: "far fa-comments text-green mr-2" }, null, -1)
const _hoisted_52 = { class: "toggle-icon" }
const _hoisted_53 = {
  key: 0,
  class: "collapsible-data"
}
const _hoisted_54 = {
  key: 0,
  class: "text-center p-3"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("p", { class: "text-muted mb-2" }, "No channel yet.", -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_57 = {
  key: 1,
  class: "row mx-n2"
}
const _hoisted_58 = { class: "kanban-wrap h-100" }
const _hoisted_59 = { class: "inner-small-wrap py-0 h-100" }
const _hoisted_60 = { class: "channel-card bg-white shadowed-box rounded" }
const _hoisted_61 = { class: "chat-card-header with-actiondropdown mb-1 mb-sm-3" }
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
const _hoisted_64 = {
  key: 0,
  class: "notification-count-wrap"
}
const _hoisted_65 = {
  key: 0,
  class: "file-actions"
}
const _hoisted_66 = { class: "dropdown" }
const _hoisted_67 = /*#__PURE__*/_createVNode("a", {
  class: "dropdown-toggle",
  type: "button",
  id: "dropdownMenuButton",
  "data-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-ellipsis-h" })
], -1)
const _hoisted_68 = {
  class: "dropdown-menu dropdown-menu-right",
  "aria-labelledby": "dropdownMenuButton"
}
const _hoisted_69 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pencil-alt mr-2" }, null, -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye-slash mr-2" }, null, -1)
const _hoisted_72 = { class: "bg-light p-2 rounded mb-2 mt-sm-0 mt-2" }
const _hoisted_73 = {
  key: 0,
  class: "to-upper"
}
const _hoisted_74 = {
  key: 0,
  class: "active-status"
}
const _hoisted_75 = {
  key: 1,
  class: "close-status"
}
const _hoisted_76 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-clock text-green mr-1" }, null, -1)
const _hoisted_77 = { class: "row mx-n1 align-items-center" }
const _hoisted_78 = { class: "col-sm-9 col-6 px-1" }
const _hoisted_79 = {
  key: 0,
  class: "members-list pt-0"
}
const _hoisted_80 = { key: 0 }
const _hoisted_81 = { key: 1 }
const _hoisted_82 = { class: "more-member" }
const _hoisted_83 = {
  key: 0,
  class: "col-sm-3 col-6 text-right px-1"
}
const _hoisted_84 = /*#__PURE__*/_createVNode("span", { class: "small-round-icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" })
], -1)
const _hoisted_85 = { class: "channel-information channel-member-addition" }
const _hoisted_86 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("i", { class: "fas fa-user-plus" }, null, -1)
const _hoisted_88 = {
  key: 2,
  class: "text-center"
}
const _hoisted_89 = { class: "right-col-wrap flex-shrink-0 h-100 py-3" }
const _hoisted_90 = { class: "vertical-nav text-center" }
const _hoisted_91 = /*#__PURE__*/_createVNode("i", { class: "fa fa-users" }, null, -1)
const _hoisted_92 = /*#__PURE__*/_createVNode("span", { class: "d-block" }, "Members", -1)
const _hoisted_93 = /*#__PURE__*/_createVNode("i", { class: "fa fa-history" }, null, -1)
const _hoisted_94 = /*#__PURE__*/_createTextVNode()
const _hoisted_95 = /*#__PURE__*/_createVNode("span", { class: "d-block" }, "History", -1)
const _hoisted_96 = /*#__PURE__*/_createVNode("i", { class: "fa fa-copy" }, null, -1)
const _hoisted_97 = /*#__PURE__*/_createTextVNode()
const _hoisted_98 = /*#__PURE__*/_createVNode("span", { class: "d-block" }, "Latest Forms", -1)
const _hoisted_99 = { class: "bordered-tab-wrap" }
const _hoisted_100 = {
  class: "nav nav-tabs tab-height",
  id: "nav-tab",
  role: "tablist",
  "aria-orientation": "vertical"
}
const _hoisted_101 = {
  class: "tab-content border-top",
  id: "tabContent"
}
const _hoisted_102 = { class: "modal-wrap default-modal" }
const _hoisted_103 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createChannelByProject",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_104 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_105 = { class: "modal-content" }
const _hoisted_106 = { class: "modal-header" }
const _hoisted_107 = { class: "d-block" }
const _hoisted_108 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_109 = { class: "text-muted" }
const _hoisted_110 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_111 = { class: "modal-body" }
const _hoisted_112 = { class: "form-group" }
const _hoisted_113 = { for: "exampleInputEmail1" }
const _hoisted_114 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_115 = { class: "form-group" }
const _hoisted_116 = { for: "exampleInputEmail1" }
const _hoisted_117 = { class: "modal-footer" }
const _hoisted_118 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_119 = {
  class: "modal fade",
  id: "removeProjectShareInvitation",
  tabindex: -1,
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_120 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_121 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_122 = { class: "modal-header" }
const _hoisted_123 = {
  key: 0,
  class: "modal-title to-upper",
  id: "exampleModalLabel"
}
const _hoisted_124 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_125 = { class: "modal-body" }
const _hoisted_126 = { class: "block-list" }
const _hoisted_127 = { class: "modal-footer" }
const _hoisted_128 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_129 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "inviteMember",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_130 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_131 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_132 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_133 = { class: "modal-content" }
const _hoisted_134 = { class: "modal-header" }
const _hoisted_135 = { class: "d-block" }
const _hoisted_136 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_137 = { class: "text-muted" }
const _hoisted_138 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_139 = { class: "modal-body" }
const _hoisted_140 = { class: "form-group pt-0" }
const _hoisted_141 = { key: 0 }
const _hoisted_142 = { class: "inline-items" }
const _hoisted_143 = {
  key: 0,
  class: "form-group"
}
const _hoisted_144 = { class: "custom-control custom-switch mr-3" }
const _hoisted_145 = {
  class: "custom-control-label",
  for: "guestSwitch"
}
const _hoisted_146 = {
  key: 0,
  class: "from-group"
}
const _hoisted_147 = { class: "custom-control custom-switch mr-3" }
const _hoisted_148 = {
  class: "custom-control-label",
  for: "guestSwitch1"
}
const _hoisted_149 = {
  key: 0,
  class: "form-group"
}
const _hoisted_150 = { for: "exampleInputEmail1" }
const _hoisted_151 = { class: "mb-0" }
const _hoisted_152 = {
  key: 0,
  class: "fa fa-trash-alt"
}
const _hoisted_153 = {
  key: 1,
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_154 = { class: "mb-0" }
const _hoisted_155 = { class: "mb-0" }
const _hoisted_156 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_157 = {
  key: 2,
  class: "form-group"
}
const _hoisted_158 = { for: "exampleInputEmail1" }
const _hoisted_159 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_160 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_161 = {
  key: 1,
  class: "mb-0"
}
const _hoisted_162 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_163 = {
  key: 2,
  class: "mb-0"
}
const _hoisted_164 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_165 = {
  key: 3,
  class: "form-group"
}
const _hoisted_166 = { for: "exampleInputEmail1" }
const _hoisted_167 = { key: 0 }
const _hoisted_168 = { key: 1 }
const _hoisted_169 = {
  key: 2,
  class: "table-wrap table-responsive mb-3"
}
const _hoisted_170 = { class: "table table-bordered table-shadowed font-12" }
const _hoisted_171 = { class: "table-primary nowrap-text" }
const _hoisted_172 = { class: "form-group" }
const _hoisted_173 = { class: "form-group" }
const _hoisted_174 = { class: "form-group" }
const _hoisted_175 = { class: "input-group" }
const _hoisted_176 = { class: "form-group" }
const _hoisted_177 = { class: "form-group" }
const _hoisted_178 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_179 = { class: "form-check form-check-inline" }
const _hoisted_180 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_181 = { class: "form-check form-check-inline" }
const _hoisted_182 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_183 = { class: "text-nowrap" }
const _hoisted_184 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_185 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_186 = { class: "modal-title" }
const _hoisted_187 = { class: "text-muted" }
const _hoisted_188 = { class: "form-group mt-3" }
const _hoisted_189 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_190 = {
  class: "custom-control-label",
  for: "customRadioInline1"
}
const _hoisted_191 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_192 = {
  class: "custom-control-label",
  for: "customRadioInline2"
}
const _hoisted_193 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_194 = {
  class: "custom-control-label",
  for: "customRadioInline3"
}
const _hoisted_195 = { class: "custom-control custom-radio custom-control-inline" }
const _hoisted_196 = {
  class: "custom-control-label",
  for: "customRadioInline4"
}
const _hoisted_197 = {
  key: 3,
  class: "row"
}
const _hoisted_198 = { class: "col-md-3" }
const _hoisted_199 = { class: "form-group" }
const _hoisted_200 = {
  key: 4,
  class: "alert alert-warning text-center",
  role: "alert"
}
const _hoisted_201 = /*#__PURE__*/_createVNode("i", { class: "fa fa-info-circle me-1" }, null, -1)
const _hoisted_202 = /*#__PURE__*/_createTextVNode(" There are some errors, Please check above. ")
const _hoisted_203 = {
  key: 4,
  class: "form-group"
}
const _hoisted_204 = { for: "exampleInputEmail1" }
const _hoisted_205 = { class: "col-lg-2" }
const _hoisted_206 = { class: "form-group" }
const _hoisted_207 = { for: "exampleFullName" }
const _hoisted_208 = { class: "col-lg-3" }
const _hoisted_209 = { class: "form-group" }
const _hoisted_210 = { for: "exampleEmailInput" }
const _hoisted_211 = { class: "col-lg-3" }
const _hoisted_212 = { class: "form-group" }
const _hoisted_213 = { for: "exampleMobileNumber" }
const _hoisted_214 = { class: "input-group" }
const _hoisted_215 = /*#__PURE__*/_createVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createVNode("span", { class: "input-group-text" }, "+1")
], -1)
const _hoisted_216 = { class: "col-lg-2" }
const _hoisted_217 = { for: "notifyByFormGroup" }
const _hoisted_218 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_219 = { class: "form-check form-check-inline" }
const _hoisted_220 = {
  class: "form-check-label",
  for: "inlineCheckbox1"
}
const _hoisted_221 = { class: "form-check form-check-inline" }
const _hoisted_222 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_223 = { class: "col-lg-2" }
const _hoisted_224 = /*#__PURE__*/_createVNode("i", { class: "fas fa-plus" }, null, -1)
const _hoisted_225 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_226 = { class: "mb-0" }
const _hoisted_227 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_228 = { class: "modal-footer" }
const _hoisted_229 = { class: "modal-wrap default-modal" }
const _hoisted_230 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "successModal",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_231 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_232 = { class: "modal-content text-center" }
const _hoisted_233 = { class: "msg-header" }
const _hoisted_234 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_235 = /*#__PURE__*/_createVNode("div", { class: "icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    class: "bi bi-check-circle",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
    }),
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.97 4.97a.75.75 0 0 1 1.071 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.236.236 0 0 1 .02-.022z"
    })
  ])
], -1)
const _hoisted_236 = { class: "msg-body" }
const _hoisted_237 = { class: "msg-footer" }
const _hoisted_238 = { class: "modal-wrap default-modal" }
const _hoisted_239 = {
  class: "modal fade",
  id: "addFavProjectModal",
  tabindex: "-1",
  "aria-labelledby": "addFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_240 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_241 = { class: "modal-content" }
const _hoisted_242 = { class: "modal-header" }
const _hoisted_243 = {
  class: "modal-title",
  id: "addFavPojectLabel"
}
const _hoisted_244 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_245 = { class: "modal-body" }
const _hoisted_246 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_247 = { class: "modal-footer" }
const _hoisted_248 = { class: "modal-wrap default-modal" }
const _hoisted_249 = {
  class: "modal fade",
  id: "removeFavProjectModal",
  tabindex: "-1",
  "aria-labelledby": "removeFavPojectLabel",
  "aria-hidden": "true"
}
const _hoisted_250 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_251 = { class: "modal-content" }
const _hoisted_252 = { class: "modal-header" }
const _hoisted_253 = {
  class: "modal-title",
  id: "removeFavPojectLabel"
}
const _hoisted_254 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_255 = { class: "modal-body" }
const _hoisted_256 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_257 = { class: "modal-footer" }
const _hoisted_258 = { class: "modal-wrap default-modal" }
const _hoisted_259 = { class: "custom-modal-overlay" }
const _hoisted_260 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_261 = { class: "modal-content" }
const _hoisted_262 = { class: "modal-header" }
const _hoisted_263 = {
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_264 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_265 = { class: "modal-body" }
const _hoisted_266 = { class: "px-3" }
const _hoisted_267 = { class: "form-group" }
const _hoisted_268 = { for: "exampleInputEmail1" }
const _hoisted_269 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "*", -1)
const _hoisted_270 = { class: "form-group" }
const _hoisted_271 = { for: "exampleInputEmail1" }
const _hoisted_272 = { class: "modal-footer" }
const _hoisted_273 = { class: "modal-wrap default-modal" }
const _hoisted_274 = { class: "custom-modal-overlay" }
const _hoisted_275 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_276 = { class: "modal-content" }
const _hoisted_277 = { class: "modal-header" }
const _hoisted_278 = {
  class: "modal-title",
  id: "hidePojectLabel"
}
const _hoisted_279 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_280 = { class: "modal-body" }
const _hoisted_281 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_282 = { class: "modal-footer" }
const _hoisted_283 = { class: "modal-wrap default-modal" }
const _hoisted_284 = {
  class: "modal fade",
  id: "renameModal",
  tabindex: "-1",
  "aria-labelledby": "renameModalLabel",
  "aria-hidden": "true"
}
const _hoisted_285 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_286 = { class: "modal-content" }
const _hoisted_287 = { class: "modal-header" }
const _hoisted_288 = {
  key: 0,
  class: "modal-title to-upper",
  id: "renameModalLabel"
}
const _hoisted_289 = {
  key: 1,
  class: "modal-title",
  id: "renameModalLabel"
}
const _hoisted_290 = { class: "modal-body" }
const _hoisted_291 = { class: "text-end mb-3" }
const _hoisted_292 = /*#__PURE__*/_createVNode("i", { class: "fa fa-edit" }, null, -1)
const _hoisted_293 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_294 = /*#__PURE__*/_createVNode("span", { class: "text-danger" }, "(*)", -1)
const _hoisted_295 = {
  key: 1,
  class: "alert alert-success"
}
const _hoisted_296 = { class: "form-group" }
const _hoisted_297 = { for: "exampleInputEmail1" }
const _hoisted_298 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_299 = { class: "form-group" }
const _hoisted_300 = { for: "exampleInputEmail1" }
const _hoisted_301 = { class: "form-group" }
const _hoisted_302 = { for: "exampleInputEmail1" }
const _hoisted_303 = { class: "form-group" }
const _hoisted_304 = { for: "projectAddress" }
const _hoisted_305 = { class: "modal-footer" }
const _hoisted_306 = { class: "modal-wrap default-modal" }
const _hoisted_307 = { class: "custom-modal-overlay" }
const _hoisted_308 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_309 = { class: "modal-content" }
const _hoisted_310 = { class: "modal-header" }
const _hoisted_311 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "pendingmemberModalLabel"
}, " Pending Member ", -1)
const _hoisted_312 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_313 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_314 = { class: "col-sm-8 mb-2" }
const _hoisted_315 = { class: "member-list pr-0" }
const _hoisted_316 = { class: "round-img" }
const _hoisted_317 = {
  key: 0,
  class: "text-lowercase"
}
const _hoisted_318 = {
  key: 0,
  class: "member-contact text-muted small"
}
const _hoisted_319 = /*#__PURE__*/_createTextVNode(" ( ")
const _hoisted_320 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_321 = /*#__PURE__*/_createTextVNode(" ) ")
const _hoisted_322 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-info-circle",
  style: {"cursor":"pointer"},
  title: "More Info"
}, null, -1)
const _hoisted_323 = {
  key: 2,
  class: "member-tooltip bg-light border p-2 mt-1 rounded shadow-sm"
}
const _hoisted_324 = {
  key: 0,
  class: "col-sm-4 text-sm-right mb-2"
}
const _hoisted_325 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-trash" }),
  /*#__PURE__*/_createTextVNode(" Delete")
], -1)
const _hoisted_326 = /*#__PURE__*/_createVNode("small", null, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-share" }),
  /*#__PURE__*/_createTextVNode(" Resend")
], -1)
const _hoisted_327 = { class: "modal-footer" }
const _hoisted_328 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_329 = { class: "custom-modal-overlay" }
const _hoisted_330 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_331 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_332 = { class: "modal-header" }
const _hoisted_333 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_334 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_335 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_336 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createVNode("strong", null, " Reinviting user will:")
], -1)
const _hoisted_337 = { class: "block-list" }
const _hoisted_338 = { class: "modal-footer" }
const _hoisted_339 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_340 = { class: "custom-modal-overlay" }
const _hoisted_341 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_342 = {
  key: 0,
  class: "modal-content"
}
const _hoisted_343 = { class: "modal-header border-0" }
const _hoisted_344 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_345 = { class: "modal-body" }
const _hoisted_346 = {
  class: "alert alert-danger text-center",
  role: "alert"
}
const _hoisted_347 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_348 = /*#__PURE__*/_createTextVNode(" Are you sure ? you want to remove ")
const _hoisted_349 = { key: 0 }
const _hoisted_350 = { key: 1 }
const _hoisted_351 = { class: "modal-footer" }
const _hoisted_352 = { class: "offcanvas-header justify-content-between border-bottom d-flex" }
const _hoisted_353 = {
  class: "offcanvas-title",
  id: "offcanvasExampleLabel"
}
const _hoisted_354 = /*#__PURE__*/_createTextVNode("Members ")
const _hoisted_355 = { key: 0 }
const _hoisted_356 = { class: "offcanvas-body" }
const _hoisted_357 = { class: "custom-scroll fixed-height-canvas" }
const _hoisted_358 = { class: "card-head pb-3 py-2" }
const _hoisted_359 = { class: "inline-items" }
const _hoisted_360 = { id: "addChannelMember" }
const _hoisted_361 = /*#__PURE__*/_createVNode("i", { class: "fa fa-user-plus" }, null, -1)
const _hoisted_362 = {
  key: 0,
  class: "member-fig"
}
const _hoisted_363 = { key: 1 }
const _hoisted_364 = { class: "role-type type-owner" }
const _hoisted_365 = {
  key: 2,
  class: "time"
}
const _hoisted_366 = /*#__PURE__*/_createVNode("i", { class: "far fa-clock" }, null, -1)
const _hoisted_367 = {
  key: 3,
  class: "my-2"
}
const _hoisted_368 = /*#__PURE__*/_createVNode("i", { class: "far fa-paper-plane" }, null, -1)
const _hoisted_369 = /*#__PURE__*/_createVNode("i", { class: "fas fa-random" }, null, -1)
const _hoisted_370 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_371 = { class: "offcanvas-header justify-content-between border-bottom d-flex" }
const _hoisted_372 = /*#__PURE__*/_createVNode("h5", {
  class: "offcanvas-title",
  id: "offcanvasExample2Label"
}, "History", -1)
const _hoisted_373 = { class: "offcanvas-body" }
const _hoisted_374 = { class: "activity-img" }
const _hoisted_375 = { class: "offcanvas-header justify-content-between border-bottom d-flex" }
const _hoisted_376 = /*#__PURE__*/_createVNode("h5", {
  class: "offcanvas-title",
  id: "offcanvasExample3Label"
}, "Latest Forms", -1)
const _hoisted_377 = {
  class: "my-2 px-2",
  id: "latestFormsSearch"
}
const _hoisted_378 = { class: "input-btn" }
const _hoisted_379 = /*#__PURE__*/_createVNode("a", {
  href: "#",
  class: "btn default-btn px-1"
}, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-search" })
], -1)
const _hoisted_380 = {
  key: 0,
  class: "spinner-border",
  role: "status"
}
const _hoisted_381 = /*#__PURE__*/_createVNode("span", { class: "sr-only" }, "Loading...", -1)
const _hoisted_382 = {
  key: 1,
  class: "offcanvas-body"
}
const _hoisted_383 = { class: "see-all  px-2" }
const _hoisted_384 = { href: "javascript:void(0)" }
const _hoisted_385 = /*#__PURE__*/_createTextVNode("View all forms ")
const _hoisted_386 = /*#__PURE__*/_createVNode("i", { class: "fas fa-chevron-right" }, null, -1)
const _hoisted_387 = { class: "offcanvas-header justify-content-between border-bottom d-flex" }
const _hoisted_388 = /*#__PURE__*/_createVNode("h5", {
  class: "offcanvas-title",
  id: "offcanvasExample4Label"
}, "Share Members", -1)
const _hoisted_389 = { class: "offcanvas-body px-0" }
const _hoisted_390 = { class: "mb-3 px-3" }
const _hoisted_391 = { class: "table-responsive" }
const _hoisted_392 = { class: "table table-borderless mb-0 font-12" }
const _hoisted_393 = { class: "table-light" }
const _hoisted_394 = { key: 0 }
const _hoisted_395 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_396 = {
  key: 1,
  class: "badge badge-dim badge-info ml-1"
}
const _hoisted_397 = {
  key: 2,
  class: "badge badge-dim badge-light text-gray ml-1"
}
const _hoisted_398 = {
  key: 3,
  class: "badge badge-dim badge-success ml-1"
}
const _hoisted_399 = /*#__PURE__*/_createVNode("i", { class: "fa fa-eye mr-2" }, null, -1)
const _hoisted_400 = /*#__PURE__*/_createVNode("i", { class: "fa fa-pen" }, null, -1)
const _hoisted_401 = /*#__PURE__*/_createVNode("i", { class: "far fa-trash-alt" }, null, -1)
const _hoisted_402 = {
  key: 1,
  class: "card"
}
const _hoisted_403 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_404 = {
  class: "modal fade default-modal",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "createPrivateChannel",
  tabindex: "-1",
  "aria-labelledby": "inviteMember",
  "aria-hidden": "true"
}
const _hoisted_405 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_406 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_407 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_408 = { class: "modal-content" }
const _hoisted_409 = { class: "modal-header" }
const _hoisted_410 = { class: "d-block" }
const _hoisted_411 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_412 = { class: "text-muted" }
const _hoisted_413 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_414 = { class: "modal-body" }
const _hoisted_415 = { class: "form-group pt-0" }
const _hoisted_416 = { key: 0 }
const _hoisted_417 = {
  key: 0,
  class: "form-group"
}
const _hoisted_418 = { for: "exampleInputEmail1" }
const _hoisted_419 = { class: "email-tag" }
const _hoisted_420 = { class: "mb-0" }
const _hoisted_421 = { class: "form-group" }
const _hoisted_422 = { for: "exampleInputEmail1" }
const _hoisted_423 = { class: "mb-0" }
const _hoisted_424 = /*#__PURE__*/_createVNode("i", { class: "fa fa-trash-alt" }, null, -1)
const _hoisted_425 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_426 = {
  key: 2,
  class: "text-danger"
}
const _hoisted_427 = {
  key: 3,
  class: "table-wrap table-responsive"
}
const _hoisted_428 = { class: "table table-bordered table-shadowed my-3 font-12" }
const _hoisted_429 = { class: "table-primary nowrap-text" }
const _hoisted_430 = { class: "to-upper" }
const _hoisted_431 = { class: "form-group mb-0" }
const _hoisted_432 = { class: "form-group" }
const _hoisted_433 = { class: "input-group" }
const _hoisted_434 = { class: "form-group mb-0" }
const _hoisted_435 = { class: "form-group mb-0" }
const _hoisted_436 = { class: "form-group" }
const _hoisted_437 = {
  class: "notify-by-form-group",
  id: "notifyByFormGroup"
}
const _hoisted_438 = { class: "form-check form-check-inline" }
const _hoisted_439 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "inlineCheckbox1"
}, "Email", -1)
const _hoisted_440 = { class: "form-check form-check-inline" }
const _hoisted_441 = {
  class: "form-check-label",
  for: "inlineCheckbox2"
}
const _hoisted_442 = /*#__PURE__*/_createVNode("i", { class: "fa fa-plus" }, null, -1)
const _hoisted_443 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash-alt" }, null, -1)
const _hoisted_444 = { class: "modal-footer" }
const _hoisted_445 = { class: "modal-wrap default-modal md-size" }
const _hoisted_446 = {
  class: "modal fade",
  id: "userprofile",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_447 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_448 = { class: "modal-content" }
const _hoisted_449 = { class: "modal-header" }
const _hoisted_450 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_451 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_452 = { class: "modal-body" }
const _hoisted_453 = { class: "member-list mb-2" }
const _hoisted_454 = {
  key: 0,
  class: "member-fig"
}
const _hoisted_455 = {
  key: 1,
  class: "member-fig"
}
const _hoisted_456 = /*#__PURE__*/_createVNode("img", {
  src: "https://dummyimage.com/80x80/000/fff",
  alt: "",
  class: "img-circle"
}, null, -1)
const _hoisted_457 = { key: 2 }
const _hoisted_458 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_459 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_460 = { class: "user-body" }
const _hoisted_461 = {
  key: 0,
  class: "text-muted mb-3"
}
const _hoisted_462 = { class: "form-group" }
const _hoisted_463 = { for: "inputState" }
const _hoisted_464 = {
  key: 1,
  class: "form-group bg-light border p-3 rounded"
}
const _hoisted_465 = {
  class: "mb-0",
  for: ""
}
const _hoisted_466 = /*#__PURE__*/_createVNode("i", {
  title: "The given members belongs to the channel with a tick but not the channel without a tick.",
  class: "fa fa-info-circle text-green"
}, null, -1)
const _hoisted_467 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_468 = { class: "inline-items" }
const _hoisted_469 = { class: "custom-control custom-checkbox mb-3" }
const _hoisted_470 = {
  key: 0,
  class: "error-list mt-3"
}
const _hoisted_471 = /*#__PURE__*/_createVNode("p", null, "This user will be included in all channel.", -1)
const _hoisted_472 = {
  key: 2,
  class: "form-group"
}
const _hoisted_473 = { for: "inputState" }
const _hoisted_474 = { class: "input-group" }
const _hoisted_475 = /*#__PURE__*/_createVNode("i", { class: "far fa-calendar-alt" }, null, -1)
const _hoisted_476 = { class: "user-footer border-top pt-3" }
const _hoisted_477 = { class: "modal-wrap default-modal md-size" }
const _hoisted_478 = {
  class: "modal fade",
  id: "removefromchannel",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_479 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_480 = { class: "modal-content" }
const _hoisted_481 = { class: "modal-header" }
const _hoisted_482 = /*#__PURE__*/_createVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Remove From Channel ", -1)
const _hoisted_483 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_484 = { class: "modal-body" }
const _hoisted_485 = { class: "member-list mb-2" }
const _hoisted_486 = {
  key: 0,
  class: "member-fig"
}
const _hoisted_487 = {
  key: 1,
  class: "member-fig"
}
const _hoisted_488 = /*#__PURE__*/_createVNode("img", {
  src: "https://dummyimage.com/80x80/000/fff",
  alt: "",
  class: "img-circle"
}, null, -1)
const _hoisted_489 = { key: 2 }
const _hoisted_490 = {
  key: 3,
  class: "mb-0"
}
const _hoisted_491 = /*#__PURE__*/_createVNode("i", { class: "fas fa-envelope" }, null, -1)
const _hoisted_492 = { class: "user-body" }
const _hoisted_493 = { class: "form-group bg-light border p-3 rounded" }
const _hoisted_494 = {
  class: "mb-0",
  for: ""
}
const _hoisted_495 = /*#__PURE__*/_createVNode("i", {
  title: "The given members belongs to the channel with a tick but not the channel without a tick.",
  class: "fa fa-info-circle text-green"
}, null, -1)
const _hoisted_496 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_497 = { class: "inline-items" }
const _hoisted_498 = { class: "custom-control custom-checkbox mb-3" }
const _hoisted_499 = { class: "user-footer border-top pt-3" }
const _hoisted_500 = { class: "modal-wrap remove-user-modal default-modal" }
const _hoisted_501 = {
  class: "modal fade",
  id: "removemember",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true",
  "data-backdrop": "static",
  "data-keyboard": "false"
}
const _hoisted_502 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_503 = {
  key: 0,
  class: "modal-content h-auto"
}
const _hoisted_504 = { class: "modal-header" }
const _hoisted_505 = {
  key: 0,
  class: "modal-title to-upper",
  id: "exampleModalLabel"
}
const _hoisted_506 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_507 = { class: "modal-body" }
const _hoisted_508 = { class: "block-list" }
const _hoisted_509 = { key: 0 }
const _hoisted_510 = { key: 1 }
const _hoisted_511 = { class: "modal-footer" }
const _hoisted_512 = {
  key: 0,
  class: "modal-wrap default-modal"
}
const _hoisted_513 = { class: "custom-modal-overlay" }
const _hoisted_514 = { class: "modal-dialog modal-dialog-centered modal-sm" }
const _hoisted_515 = { class: "modal-content" }
const _hoisted_516 = { class: "modal-header" }
const _hoisted_517 = {
  class: "modal-title",
  id: "showPojectLabel"
}
const _hoisted_518 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_519 = { class: "modal-body" }
const _hoisted_520 = {
  class: "alert alert-danger mb-0",
  role: "alert"
}
const _hoisted_521 = { class: "modal-footer" }
const _hoisted_522 = { class: "modal-body" }
const _hoisted_523 = /*#__PURE__*/_createVNode("span", { class: "animating-arrow" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-right" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_multiselect = _resolveComponent("multiselect")
  const _component_draggable = _resolveComponent("draggable")
  const _component_ProjectWorkflowListJobEstimation = _resolveComponent("ProjectWorkflowListJobEstimation")
  const _component_ProjectWorkflowCreateJobEstimation = _resolveComponent("ProjectWorkflowCreateJobEstimation")
  const _component_ProjectWorkflowUpdateJobEstimation = _resolveComponent("ProjectWorkflowUpdateJobEstimation")
  const _component_ProjectWorkflowSendJobEstimation = _resolveComponent("ProjectWorkflowSendJobEstimation")
  const _component_ProjectWorkflowSmartContractList = _resolveComponent("ProjectWorkflowSmartContractList")
  const _component_ProjectWorkflowSendEstimationInvitaion = _resolveComponent("ProjectWorkflowSendEstimationInvitaion")
  const _component_ProjectWorkflowSmartContractPreview = _resolveComponent("ProjectWorkflowSmartContractPreview")
  const _component_ProjectWorkflowSendSmartContract = _resolveComponent("ProjectWorkflowSendSmartContract")
  const _component_ProjectWorkflowToDoList = _resolveComponent("ProjectWorkflowToDoList")
  const _component_ProjectWorkflowToDoPhaseAddMember = _resolveComponent("ProjectWorkflowToDoPhaseAddMember")
  const _component_ProjectWorkflowToDoDetails = _resolveComponent("ProjectWorkflowToDoDetails")
  const _component_ProjectWorkflowList = _resolveComponent("ProjectWorkflowList")
  const _component_ProjectWorkflowToDoTaskLogList = _resolveComponent("ProjectWorkflowToDoTaskLogList")
  const _component_ProjectWorkflowEditTask = _resolveComponent("ProjectWorkflowEditTask")
  const _component_ProjectWorkflowInvoiceList = _resolveComponent("ProjectWorkflowInvoiceList")
  const _component_ProjectWorkflowToDoPhaseInvoice = _resolveComponent("ProjectWorkflowToDoPhaseInvoice")
  const _component_AppPhoneNumberInput = _resolveComponent("AppPhoneNumberInput")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_GoogleMapView = _resolveComponent("GoogleMapView")
  const _component_TemplateCard = _resolveComponent("TemplateCard")
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_ProjectImageUploadModal = _resolveComponent("ProjectImageUploadModal")
  const _component_ShowMemberListModal = _resolveComponent("ShowMemberListModal")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, " Project : " + _toDisplayString(_ctx.state.data.projectDetail.project.name), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("nav", _hoisted_6, [
              _createVNode("ol", _hoisted_7, [
                _createVNode("li", _hoisted_8, [
                  _createVNode(_component_router_link, { to: { name: 'admin-dashboard' } }, {
                    default: _withId(() => [
                      _hoisted_9,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('home')), 1)
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode("ul", null, [
              _createVNode("li", null, [
                _createVNode("div", _hoisted_12, [
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createVNode("div", _hoisted_15, [
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.renameProjectModal && _ctx.renameProjectModal(...args)))
                      }, [
                        _hoisted_16,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('view_project_details')), 1)
                      ]),
                      _createVNode("a", {
                        class: "dropdown-item",
                        href: "javascript:void(0)",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeProjectImageUploadModal && _ctx.closeProjectImageUploadModal(...args)))
                      }, [
                        _hoisted_17,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('view_project_gallery')), 1)
                      ]),
                      (_ctx.state.data.projectDetail.fav === 1)
                        ? (_openBlock(), _createBlock("a", {
                            key: 0,
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectShow && _ctx.removeFavProjectShow(...args)))
                          }, [
                            _hoisted_18,
                            _hoisted_19
                          ]))
                        : (_openBlock(), _createBlock("a", {
                            key: 1,
                            class: "dropdown-item",
                            href: "javascript:void(0)",
                            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectShow && _ctx.addFavProjectShow(...args)))
                          }, [
                            _hoisted_20,
                            _hoisted_21
                          ]))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_22, [
      _createVNode("div", _hoisted_23, [
        _createVNode("ul", _hoisted_24, [
          _createVNode("li", _hoisted_25, [
            _createVNode("button", {
              class: { 'nav-link': true, active: _ctx.activeTab === 'chat' },
              id: "chat-tab",
              "data-toggle": "tab",
              "data-target": "#chat",
              type: "button",
              role: "tab",
              "aria-controls": "chat",
              "aria-selected": _ctx.activeTab === 'chat',
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.switchTab('chat')))
            }, [
              _hoisted_26,
              _hoisted_27
            ], 10, ["aria-selected"])
          ]),
          (_ctx.canShowWorkflow)
            ? (_openBlock(), _createBlock("li", _hoisted_28, [
                _createVNode("button", {
                  class: { 'nav-link': true, active: _ctx.activeTab === 'workflow' },
                  id: "workflow-tab",
                  "data-toggle": "tab",
                  "data-target": "#workflow",
                  type: "button",
                  role: "tab",
                  "aria-controls": "workflow",
                  "aria-selected": _ctx.activeTab === 'workflow',
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.switchTab('workflow')))
                }, [
                  _hoisted_29,
                  _hoisted_30
                ], 10, ["aria-selected"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_31, [
          (_ctx.activeTab === 'chat')
            ? (_openBlock(), _createBlock("div", {
                key: 0,
                class: { 'tab-pane': true, show: _ctx.activeTab === 'chat', active: _ctx.activeTab === 'chat' },
                id: "chat",
                role: "tabpanel",
                "aria-labelledby": "chat-tab"
              }, [
                (_ctx.state.ui.isLoading.getProjectDetail)
                  ? (_openBlock(), _createBlock("div", _hoisted_32, [
                      _hoisted_33
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.errors.errorList.errorList,
                  hasError: _ctx.state.ui.errors.hasError
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", _hoisted_34, [
                  _createVNode("div", _hoisted_35, [
                    _createVNode("div", _hoisted_36, [
                      _createVNode("div", _hoisted_37, [
                        _createVNode("div", _hoisted_38, [
                          _createVNode(_component_multiselect, {
                            modelValue: _ctx.state.data.selectedChannel,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.selectedChannel = $event)),
                            options: _ctx.state.data.allChannels,
                            "close-on-select": "true",
                            "clear-on-select": "true",
                            placeholder: _ctx.$t('search_and_select'),
                            onSelect: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeSelectedChannel(_ctx.state.data.selectedChannel))),
                            label: "name",
                            "track-by": "id"
                          }, null, 8, ["modelValue", "options", "placeholder"])
                        ])
                      ]),
                      _createVNode("div", _hoisted_39, [
                        _createVNode("a", {
                          href: "javascript:void(0)",
                          class: "text-success to-upper",
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.searchChannelRemove && _ctx.searchChannelRemove(...args)))
                        }, [
                          _hoisted_40,
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('reset')), 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_41, [
                        _createVNode("div", _hoisted_42, [
                          _createVNode("ul", null, [
                            _createVNode("li", null, [
                              _createVNode("div", _hoisted_43, [
                                _hoisted_44,
                                _withDirectives(_createVNode("select", {
                                  class: "form-control",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.state.data.channelStatus = $event)),
                                  onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.changeChannelStatus && _ctx.changeChannelStatus(...args)))
                                }, [
                                  _createVNode("option", _hoisted_45, _toDisplayString(_ctx.$t('active')), 1),
                                  _createVNode("option", _hoisted_46, _toDisplayString(_ctx.$t('closed')), 1),
                                  _createVNode("option", _hoisted_47, _toDisplayString(_ctx.$t('hide')), 1)
                                ], 544), [
                                  [_vModelSelect, _ctx.state.data.channelStatus]
                                ])
                              ])
                            ]),
                            (_ctx.state.data.projectDetail.project.status_id !== 2)
                              ? (_openBlock(), _createBlock("li", _hoisted_48, [
                                  (_ctx.isUserStatus)
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 0,
                                        href: "javascript:void(0)",
                                        class: "d-block create-url",
                                        id: "343newChannel",
                                        onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.showCreateProjectChannel && _ctx.showCreateProjectChannel(...args)))
                                      }, [
                                        _hoisted_49,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('create_channel')), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ]),
                    _createVNode("div", _hoisted_50, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectDetail.channels, (channel, channelIndex) => {
                        return (_openBlock(), _createBlock("div", {
                          key: channelIndex,
                          class: "collapsible-item"
                        }, [
                          _createVNode("div", {
                            class: "collapsible-head",
                            onClick: ($event: any) => (_ctx.toggleCollapse(channelIndex))
                          }, [
                            _createVNode("span", null, [
                              _hoisted_51,
                              _createTextVNode(" " + _toDisplayString(channel.name) + " Channel (" + _toDisplayString(channel.count) + ")", 1)
                            ]),
                            _createVNode("span", _hoisted_52, _toDisplayString(channel.isActive ? '-' : '+'), 1)
                          ], 8, ["onClick"]),
                          (channel.isActive)
                            ? (_openBlock(), _createBlock("div", _hoisted_53, [
                                (channel.name === 'Project' && channel.list.data.length === 0)
                                  ? (_openBlock(), _createBlock("div", _hoisted_54, [
                                      _hoisted_55,
                                      (_ctx.isUserStatus && _ctx.state.data.projectDetail.project.status_id !== 2)
                                        ? (_openBlock(), _createBlock("a", {
                                            key: 0,
                                            href: "javascript:void(0)",
                                            class: "d-block create-url",
                                            id: "343newChannel",
                                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.showCreateProjectChannel && _ctx.showCreateProjectChannel(...args)))
                                          }, [
                                            _hoisted_56,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('create_channel')), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : (_openBlock(), _createBlock("div", _hoisted_57, [
                                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(channel.list.data, (channelCard, channelCardIndex) => {
                                        return (_openBlock(), _createBlock("div", {
                                          class: "col-lg-6 col-sm-6 px-2 mb-1nvm ",
                                          key: channelCardIndex
                                        }, [
                                          _createVNode("div", _hoisted_58, [
                                            _createVNode("div", _hoisted_59, [
                                              _createVNode(_component_draggable, {
                                                class: "dragArea list-group w-full h-100",
                                                disabled: _ctx.isMobile,
                                                holdToMove: true,
                                                list: channel.list.data,
                                                onChange: _ctx.orderChange
                                              }, {
                                                default: _withId(() => [
                                                  _createVNode(_TransitionGroup, null, {
                                                    default: _withId(() => [
                                                      _createVNode("div", _hoisted_60, [
                                                        _createVNode("div", _hoisted_61, [
                                                          _createVNode("h5", _hoisted_62, [
                                                            _createVNode(_component_router_link, {
                                                              to: {
                                        name: 'admin-channel',
                                        params: { channelId: channelCard.uuid},
                                        query: { projectStatus: _ctx.state.data.projectDetail.project.status_id }
,
                                      },
                                                              class: "d-block"
                                                            }, {
                                                              default: _withId(() => [
                                                                _createTextVNode(_toDisplayString(_ctx.$t('channel')) + " : " + _toDisplayString(channelCard.name) + " ", 1),
                                                                _hoisted_63,
                                                                (channelCard.notification_count != 0)
                                                                  ? (_openBlock(), _createBlock("span", _hoisted_64, _toDisplayString(channelCard.notification_count) + " " + _toDisplayString(_ctx.$t('unread_message')), 1))
                                                                  : _createCommentVNode("", true)
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["to"])
                                                          ]),
                                                          (_ctx.state.data.projectDetail.project.status_id !== 2)
                                                            ? (_openBlock(), _createBlock("div", _hoisted_65, [
                                                                _createVNode("div", _hoisted_66, [
                                                                  _hoisted_67,
                                                                  _createVNode("div", _hoisted_68, [
                                                                    (
                                                _ctx.isUserStatus
                                                && channelCard.status === 'Active'
                                                && (channel.id === 1 || channel.id === 4)
                                              )
                                                                      ? (_openBlock(), _createBlock("a", {
                                                                          key: 0,
                                                                          class: "dropdown-item to-upper",
                                                                          href: "javascript:void(0)",
                                                                          onClick: ($event: any) => (_ctx.showEditChannelModal(channelCard))
                                                                        }, [
                                                                          _hoisted_69,
                                                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('edit')), 1)
                                                                        ], 8, ["onClick"]))
                                                                      : _createCommentVNode("", true),
                                                                    (channelCard.visible && channel.id != 4)
                                                                      ? (_openBlock(), _createBlock("a", {
                                                                          key: 1,
                                                                          class: "dropdown-item",
                                                                          href: "javascript:void(0)",
                                                                          onClick: ($event: any) => (_ctx.showChannelShow(channelCard))
                                                                        }, [
                                                                          _hoisted_70,
                                                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('show')), 1)
                                                                        ], 8, ["onClick"]))
                                                                      : _createCommentVNode("", true),
                                                                    (!channelCard.visible && channel.id != 4)
                                                                      ? (_openBlock(), _createBlock("a", {
                                                                          key: 2,
                                                                          class: "dropdown-item",
                                                                          href: "javascript:void(0)",
                                                                          onClick: ($event: any) => (_ctx.hideChannelShow(channelCard))
                                                                        }, [
                                                                          _hoisted_71,
                                                                          _createTextVNode(" " + _toDisplayString(_ctx.$t('hide')), 1)
                                                                        ], 8, ["onClick"]))
                                                                      : _createCommentVNode("", true)
                                                                  ])
                                                                ])
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _createVNode("div", _hoisted_72, [
                                                          _createVNode("p", null, _toDisplayString(channelCard.description), 1),
                                                          (_ctx.state.data.projectDetail.project.status_id !== 2)
                                                            ? (_openBlock(), _createBlock("p", _hoisted_73, [
                                                                _createVNode("strong", null, _toDisplayString(_ctx.$t('status')) + " :", 1),
                                                                (channelCard.status === 'Active')
                                                                  ? (_openBlock(), _createBlock("span", _hoisted_74, _toDisplayString(channelCard.status), 1))
                                                                  : (_openBlock(), _createBlock("span", _hoisted_75, _toDisplayString(_ctx.$t('closed')), 1))
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _createVNode("p", null, [
                                                          _createVNode("small", null, [
                                                            _hoisted_76,
                                                            _createTextVNode(" " + _toDisplayString(channelCard.createdMessage), 1)
                                                          ])
                                                        ]),
                                                        _createVNode("div", _hoisted_77, [
                                                          _createVNode("div", _hoisted_78, [
                                                            (channelCard.active_members &&
                                          channelCard.active_members.length &&
                                          channelCard.deleted_at == null
                                        )
                                                              ? (_openBlock(), _createBlock("div", _hoisted_79, [
                                                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(channelCard.active_members.slice(
                                              0,
                                              3
                                            ), (member, memberIndex) => {
                                                                    return (_openBlock(), _createBlock("a", {
                                                                      href: "javascript:void(0)",
                                                                      onClick: ($event: any) => (_ctx.showMemberList(channelCard.active_members)),
                                                                      key: memberIndex
                                                                    }, [
                                                                      (!member.deleted_at)
                                                                        ? (_openBlock(), _createBlock("span", _hoisted_80, [
                                                                            (member.image)
                                                                              ? (_openBlock(), _createBlock("img", {
                                                                                  key: 0,
                                                                                  src: member.image,
                                                                                  alt: "",
                                                                                  title: `${member.first_name} ${member.last_name}` +
                                                ' (' +
                                                `${member.email}` +
                                                ')'
                                                
                                                                                }, null, 8, ["src", "title"]))
                                                                              : (_openBlock(), _createBlock("img", {
                                                                                  key: 1,
                                                                                  src: _ctx.state.data.imageBaseUrl
                                                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                                : 'img/no-user.jpg'
                                                ,
                                                                                  alt: "",
                                                                                  title: `${member.first_name} ${member.last_name}` +
                                                  '(' +
                                                  `${member.email}` +
                                                  ')'
                                                  
                                                                                }, null, 8, ["src", "title"]))
                                                                          ]))
                                                                        : (channelCard.active_members &&
                                              channelCard.active_members.length &&
                                              _ctx.state.projectDetail.deleted_at != null
                                            )
                                                                          ? (_openBlock(), _createBlock("span", _hoisted_81, [
                                                                              (member.image)
                                                                                ? (_openBlock(), _createBlock("img", {
                                                                                    key: 0,
                                                                                    src: member.image,
                                                                                    alt: "",
                                                                                    title: `${member.first_name} ${member.last_name}` +
                                                ' (' +
                                                `${member.email}` +
                                                ')'
                                                
                                                                                  }, null, 8, ["src", "title"]))
                                                                                : (_openBlock(), _createBlock("img", {
                                                                                    key: 1,
                                                                                    src: _ctx.state.data.imageBaseUrl
                                                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                                                : 'img/no-user.jpg'
                                                ,
                                                                                    alt: "",
                                                                                    title: `${member.full_name}` +
                                                  '(' +
                                                  `${member.email}` +
                                                  ')'
                                                  
                                                                                  }, null, 8, ["src", "title"]))
                                                                            ]))
                                                                          : _createCommentVNode("", true)
                                                                    ], 8, ["onClick"]))
                                                                  }), 128)),
                                                                  (channelCard.active_members.length > 3)
                                                                    ? (_openBlock(), _createBlock("a", {
                                                                        key: 0,
                                                                        href: "javascript:void(0)",
                                                                        onClick: ($event: any) => (_ctx.showMemberList(channelCard.active_members))
                                                                      }, [
                                                                        _createVNode("span", _hoisted_82, "+" + _toDisplayString(channelCard.active_members.length - 3), 1)
                                                                      ], 8, ["onClick"]))
                                                                    : _createCommentVNode("", true)
                                                                ]))
                                                              : _createCommentVNode("", true)
                                                          ]),
                                                          (channelCard.status === 'Active' && _ctx.isUserStatus && channel.id === 1)
                                                            ? (_openBlock(), _createBlock("div", _hoisted_83, [
                                                                (_ctx.state.data.projectDetail.project.status_id !== 2)
                                                                  ? (_openBlock(), _createBlock("a", {
                                                                      key: 0,
                                                                      class: "d-block create-url",
                                                                      href: "javascript:void(0)",
                                                                      onClick: ($event: any) => (_ctx.addMember(channel, channelCard))
                                                                    }, [
                                                                      _hoisted_84,
                                                                      _createTextVNode(" " + _toDisplayString(_ctx.$t('add_member')), 1)
                                                                    ], 8, ["onClick"]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ]),
                                                        _createVNode("div", _hoisted_85, [
                                                          (_ctx.isUserStatus && channelCard.pending_members && channelCard.pending_members.length
                                      )
                                                            ? (_openBlock(), _createBlock("div", _hoisted_86, [
                                                                _createVNode("a", {
                                                                  href: "javascript:void(0)",
                                                                  onClick: ($event: any) => (_ctx.showPendingList(channelCard)),
                                                                  class: "btn btn-outline-primary"
                                                                }, [
                                                                  _hoisted_87,
                                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('pending_members')) + " (" + _toDisplayString(channelCard.pending_members.length) + ")", 1)
                                                                ], 8, ["onClick"])
                                                              ]))
                                                            : _createCommentVNode("", true)
                                                        ])
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _: 2
                                              }, 1032, ["disabled", "list", "onChange"])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ])),
                                (channel.list.current_page != channel.list.last_page)
                                  ? (_openBlock(), _createBlock("div", _hoisted_88, [
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        class: "btn default-btn",
                                        onClick: ($event: any) => (_ctx.channelListByChannelGroup(channel))
                                      }, "Load more", 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createVNode("div", _hoisted_89, [
                    _createVNode("div", _hoisted_90, [
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          _createVNode("a", {
                            role: "button",
                            onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.toggleSidebar('sidebar-members'))),
                            "aria-controls": "offcanvasExample"
                          }, [
                            _hoisted_91,
                            _hoisted_92
                          ])
                        ]),
                        _createVNode("li", null, [
                          _createVNode("a", {
                            role: "button",
                            onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.toggleSidebar('sidebar-history'))),
                            "aria-controls": "offcanvasExample2"
                          }, [
                            _hoisted_93,
                            _hoisted_94,
                            _hoisted_95
                          ])
                        ]),
                        _createVNode("li", null, [
                          _createVNode("a", {
                            role: "button",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleSidebar('sidebar-latest-forms'))),
                            "aria-controls": "offcanvasExample3"
                          }, [
                            _hoisted_96,
                            _hoisted_97,
                            _hoisted_98
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.activeTab === 'workflow')
            ? (_openBlock(), _createBlock("div", {
                key: 1,
                class: { 'tab-pane': true, show: _ctx.activeTab === 'workflow', active: _ctx.activeTab === 'workflow' },
                id: "workflow",
                role: "tabpanel",
                "aria-labelledby": "workflow-tab"
              }, [
                _createVNode("div", _hoisted_99, [
                  _createVNode("div", _hoisted_100, [
                    (_ctx.canShowWorkflow)
                      ? (_openBlock(), _createBlock("button", {
                          key: 0,
                          class: { 'nav-link': true, active: _ctx.activeSubTab === 'jobEstimation' },
                          id: "tab1-tab",
                          "data-toggle": "pill",
                          "data-target": "#tab1",
                          type: "button",
                          role: "tab",
                          "aria-controls": "tab1",
                          "aria-selected": _ctx.activeSubTab === 'jobEstimation',
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.switchWorkflowTab('jobEstimation')))
                        }, "Job Estimation", 10, ["aria-selected"]))
                      : _createCommentVNode("", true),
                    _createVNode("button", {
                      class: { 'nav-link': true, active: _ctx.activeSubTab === 'smartContract' },
                      id: "tab2-tab",
                      "data-toggle": "pill",
                      "data-target": "#tab2",
                      type: "button",
                      role: "tab",
                      "aria-controls": "tab2",
                      "aria-selected": _ctx.activeSubTab === 'smartContract',
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.switchWorkflowTab('smartContract')))
                    }, "Smart Contract", 10, ["aria-selected"]),
                    _createVNode("button", {
                      class: { 'nav-link': true, active: _ctx.activeSubTab === 'subWorkFlow' },
                      id: "tab3-tab",
                      "data-toggle": "pill",
                      "data-target": "#tab3",
                      type: "button",
                      role: "tab",
                      "aria-controls": "tab3",
                      "aria-selected": _ctx.activeSubTab === 'subWorkFlow',
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.switchWorkflowTab('subWorkFlow')))
                    }, "Workflow", 10, ["aria-selected"]),
                    _createVNode("button", {
                      class: { 'nav-link': true, active: _ctx.activeSubTab === 'invoices' },
                      id: "tab4-tab",
                      "data-toggle": "pill",
                      "data-target": "#tab4",
                      type: "button",
                      role: "tab",
                      "aria-controls": "tab4",
                      "aria-selected": _ctx.activeSubTab === 'invoices',
                      onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.switchWorkflowTab('invoices')))
                    }, "Invoice", 10, ["aria-selected"])
                  ]),
                  _createVNode("div", _hoisted_101, [
                    (_ctx.activeSubTab === 'jobEstimation')
                      ? (_openBlock(), _createBlock("div", {
                          key: 0,
                          class: { 'tab-pane p-0 border-none  px-0': true, fade: true, show: _ctx.activeSubTab === 'jobEstimation', active: _ctx.activeSubTab === 'jobEstimation' },
                          id: "tab1",
                          role: "tabpanel",
                          "aria-labelledby": "tab1-tab"
                        }, [
                          (_ctx.activeComponent === 'listJobEstimation')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowListJobEstimation, {
                                key: 0,
                                onCreateJobEstimation: _ctx.openCreateJobEstimation,
                                onEditJobEstimation: _ctx.openEditJobEstimation,
                                onUpdateJobEstimation: _ctx.openUpdateJobEstimation,
                                onSendJobEstimation: _ctx.openSendJobEstimation,
                                onCreateEstimationInvitation: _ctx.handleCreateEstimationInvitation,
                                "project-status": _ctx.state.data.projectDetail.project.status_id
                              }, null, 8, ["onCreateJobEstimation", "onEditJobEstimation", "onUpdateJobEstimation", "onSendJobEstimation", "onCreateEstimationInvitation", "project-status"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'createJobEstimation')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowCreateJobEstimation, {
                                key: 1,
                                "edit-id": _ctx.currentEstimationId,
                                onBackToJobEstimationList: _ctx.openListJobEstimation,
                                onSendJobEstimation: _ctx.openSendJobEstimation,
                                ref: "jobEstimationFormRef"
                              }, null, 8, ["edit-id", "onBackToJobEstimationList", "onSendJobEstimation"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'updateJobEstimation')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowUpdateJobEstimation, {
                                key: 2,
                                "edit-id": _ctx.currentEstimationId,
                                onBackToJobEstimationList: _ctx.openListJobEstimation
                              }, null, 8, ["edit-id", "onBackToJobEstimationList"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'sendJobEstimation')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSendJobEstimation, {
                                key: 3,
                                "estimation-id": _ctx.currentEstimationId,
                                "project-name": _ctx.state.data.projectDetail.project.name,
                                onBackToJobEstimationList: _ctx.openListJobEstimation
                              }, null, 8, ["estimation-id", "project-name", "onBackToJobEstimationList"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.activeSubTab === 'smartContract')
                      ? (_openBlock(), _createBlock("div", {
                          key: 1,
                          class: { 'tab-pane p-0 border-none': true, fade: true, show: _ctx.activeSubTab === 'smartContract', active: _ctx.activeSubTab === 'smartContract' },
                          id: "tab2",
                          role: "tabpanel",
                          "aria-labelledby": "tab2-tab"
                        }, [
                          (_ctx.activeComponent === 'listSmartContract')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSmartContractList, {
                                key: 0,
                                onSmartContractPreview: _ctx.openSmartContractPreview,
                                onSendSmartContract: _ctx.openSendSmartContract,
                                onUserToDoList: _ctx.openToDoList,
                                "project-status": _ctx.state.data.projectDetail.project.status_id
                              }, null, 8, ["onSmartContractPreview", "onSendSmartContract", "onUserToDoList", "project-status"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'sendEstimationInvitation')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSendEstimationInvitaion, {
                                key: 1,
                                "estimation-id": _ctx.currentEstimationId,
                                onRedirectToJobEstimationList: _ctx.redirectListJobEstimation,
                                onBackToSmartContractList: _ctx.openListSmartContract
                              }, null, 8, ["estimation-id", "onRedirectToJobEstimationList", "onBackToSmartContractList"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'smartContractPreview')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSmartContractPreview, {
                                key: 2,
                                "contract-id": _ctx.currentEstimationId,
                                onBackToSmartContractList: _ctx.openListSmartContract
                              }, null, 8, ["contract-id", "onBackToSmartContractList"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'sendSmartContract')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSendSmartContract, {
                                key: 3,
                                contractId: _ctx.currentUuid,
                                estimationId: _ctx.currentEstimationId,
                                onBackToSmartContractList: _ctx.openListSmartContract
                              }, null, 8, ["contractId", "estimationId", "onBackToSmartContractList"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.activeTab === 'smartContract')
                      ? (_openBlock(), _createBlock("div", {
                          key: 2,
                          class: { 'tab-pane p-0 border-none': true, fade: true, show: _ctx.activeTab === 'smartContract', active: _ctx.activeTab === 'smartContract' },
                          id: "tab2",
                          role: "tabpanel",
                          "aria-labelledby": "tab2-tab"
                        }, [
                          (_ctx.activeComponent === 'listSmartContract')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSmartContractList, {
                                key: 0,
                                onSmartContractPreview: _ctx.openSmartContractPreview,
                                onSendSmartContract: _ctx.openSendSmartContract
                              }, null, 8, ["onSmartContractPreview", "onSendSmartContract"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'sendEstimationInvitation')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSendEstimationInvitaion, {
                                key: 1,
                                "estimation-id": _ctx.currentEstimationId,
                                onRedirectToJobEstimationList: _ctx.redirectListJobEstimation,
                                onBackToSmartContractList: _ctx.openListSmartContract
                              }, null, 8, ["estimation-id", "onRedirectToJobEstimationList", "onBackToSmartContractList"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'smartContractPreview')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowSmartContractPreview, {
                                key: 2,
                                "contract-id": _ctx.currentEstimationId,
                                onBackToSmartContractList: _ctx.openListSmartContract
                              }, null, 8, ["contract-id", "onBackToSmartContractList"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.activeSubTab === 'subWorkFlow')
                      ? (_openBlock(), _createBlock("div", {
                          key: 3,
                          class: { 'tab-pane p-0 border-none': true, fade: true, show: _ctx.activeSubTab === 'subWorkFlow', active: _ctx.activeSubTab === 'subWorkFlow' },
                          id: "tab3",
                          role: "tabpanel",
                          "aria-labelledby": "tab3-tab"
                        }, [
                          (_ctx.activeComponent === 'toDoList')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowToDoList, {
                                key: 0,
                                "project-id": _ctx.currentUuid,
                                onBackToSmartContractList: _ctx.backFromToDoList,
                                "previous-component": _ctx.previousComponent
                              }, null, 8, ["project-id", "onBackToSmartContractList", "previous-component"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'toDoPhaseAddMember')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowToDoPhaseAddMember, {
                                key: 1,
                                "phase-id": _ctx.state.activePhaseId,
                                "parent-task-id": _ctx.state.activeTaskId
                              }, null, 8, ["phase-id", "parent-task-id"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'toDoDetails')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowToDoDetails, {
                                key: 2,
                                "prop-phase-id": _ctx.state.activePhaseId,
                                permission: _ctx.state.permission,
                                onBackUserTodoList: _ctx.backFromToDoDetails,
                                onUserPhaseInvoice: _ctx.openToDoPhaseInvoice,
                                onUserTodoTaskLogDetails: _ctx.openToDoTaskLogList
                              }, null, 8, ["prop-phase-id", "permission", "onBackUserTodoList", "onUserPhaseInvoice", "onUserTodoTaskLogDetails"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'workflowList')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowList, {
                                key: 3,
                                onUserToDoList: _ctx.openToDoList
                              }, null, 8, ["onUserToDoList"]))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'toDoTaskLogList')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowToDoTaskLogList, {
                                key: 4,
                                "phase-id": _ctx.state.activePhaseId,
                                id: _ctx.state.activeTaskId
                              }, null, 8, ["phase-id", "id"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true),
                    (_ctx.activeComponent === 'editTask')
                      ? (_openBlock(), _createBlock(_component_ProjectWorkflowEditTask, {
                          key: 4,
                          taskId: _ctx.state.activeTaskId
                        }, null, 8, ["taskId"]))
                      : _createCommentVNode("", true),
                    (_ctx.activeSubTab === 'invoices')
                      ? (_openBlock(), _createBlock("div", {
                          key: 5,
                          class: { 'tab-pane p-0 border-none': true, fade: true, show: _ctx.activeSubTab === 'invoices', active: _ctx.activeSubTab === 'invoices' },
                          id: "tab2",
                          role: "tabpanel",
                          "aria-labelledby": "tab2-tab"
                        }, [
                          (_ctx.activeComponent === 'invoiceList')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowInvoiceList, { key: 0 }))
                            : _createCommentVNode("", true),
                          (_ctx.activeComponent === 'toDoPhaseInvoice')
                            ? (_openBlock(), _createBlock(_component_ProjectWorkflowToDoPhaseInvoice, {
                                key: 1,
                                "phase-id": _ctx.currentUuid,
                                noPermission: _ctx.state.permission
                              }, null, 8, ["phase-id", "noPermission"]))
                            : _createCommentVNode("", true)
                        ], 2))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_102, [
      _createVNode("div", _hoisted_103, [
        _createVNode("div", _hoisted_104, [
          _createVNode("div", _hoisted_105, [
            _createVNode("div", _hoisted_106, [
              _createVNode("div", _hoisted_107, [
                _createVNode("h5", _hoisted_108, _toDisplayString(_ctx.$t('create_channel')), 1),
                _createVNode("p", _hoisted_109, _toDisplayString(_ctx.$t('channels_team_communication')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.hideCreateChannel && _ctx.hideCreateChannel(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_110
              ])
            ]),
            _createVNode("div", _hoisted_111, [
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.createChannel,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_112, [
                _createVNode("label", _hoisted_113, [
                  _createTextVNode(_toDisplayString(_ctx.$t('channel_name')) + " ", 1),
                  _hoisted_114
                ]),
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  placeholder: _ctx.$t('example_kitchen_modeling_team'),
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.state.data.createChannel.name = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.createChannel.name]
                ])
              ]),
              _createVNode("div", _hoisted_115, [
                _createVNode("label", _hoisted_116, _toDisplayString(_ctx.$t('description')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "10",
                  placeholder: _ctx.$t('description_of_channel'),
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.state.data.createChannel.description = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.createChannel.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_117, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.createChannel && _ctx.createChannel(...args)))
              }, " Create Channel ")
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_118, [
      _createVNode("div", _hoisted_119, [
        _createVNode("div", _hoisted_120, [
          (_ctx.state.data.selectedShareInvitationForRemoval)
            ? (_openBlock(), _createBlock("div", _hoisted_121, [
                _createVNode("div", _hoisted_122, [
                  (_ctx.state.data.selectedShareInvitationForRemoval &&
                _ctx.state.data.selectedShareInvitationForRemoval.email
              )
                    ? (_openBlock(), _createBlock("h5", _hoisted_123, _toDisplayString(_ctx.$t('remove')) + " " + _toDisplayString(_ctx.state.data.selectedShareInvitationForRemoval.email) + " ? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.hideShareProjectRemove && _ctx.hideShareProjectRemove(...args)))
                  }, [
                    _hoisted_124
                  ])
                ]),
                _createVNode("div", _hoisted_125, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.removeProjectRole,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('removing_user')) + ":", 1)
                  ]),
                  _createVNode("div", _hoisted_126, [
                    _createVNode("ul", null, [
                      _createVNode("li", null, _toDisplayString(_ctx.state.data.selectedShareInvitationForRemoval.email) + " " + _toDisplayString(_ctx.$t('removal_warning')), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_127, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn to-upper",
                    onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.hideShareProjectRemove && _ctx.hideShareProjectRemove(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.removeShareInvitation && _ctx.removeShareInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.removeShareInvitation
                ? _ctx.$t('removing')
                : _ctx.$t('yes_remove_user')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_128, [
      _createVNode("div", _hoisted_129, [
        (_ctx.state.ui.isPostLoading.inviteAllUsers)
          ? (_openBlock(), _createBlock("div", _hoisted_130, [
              _hoisted_131
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_132, [
          _createVNode("div", _hoisted_133, [
            _createVNode("div", _hoisted_134, [
              _createVNode("div", _hoisted_135, [
                _createVNode("h5", _hoisted_136, _toDisplayString(_ctx.$t('invite_member')), 1),
                _createVNode("p", _hoisted_137, _toDisplayString(_ctx.$t('create_project_collaboration')) + ". ", 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_138
              ])
            ]),
            _createVNode("div", _hoisted_139, [
              _createVNode("div", _hoisted_140, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.errorList,
                  hasError: _ctx.state.isErrorStatus
                }, null, 8, ["errors", "hasError"]),
                (!_ctx.state.data.invitationVerify.showStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_141, [
                      _createVNode("div", _hoisted_142, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, [
                            (!_ctx.state.data.inviteAsPublicUser)
                              ? (_openBlock(), _createBlock("div", _hoisted_143, [
                                  _createVNode("div", _hoisted_144, [
                                    _withDirectives(_createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "guestSwitch",
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.state.data.inviteAsGuest = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.state.data.inviteAsGuest]
                                    ]),
                                    _createVNode("label", _hoisted_145, _toDisplayString(_ctx.$t('as_guest')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("li", null, [
                            (!_ctx.state.data.inviteAsGuest)
                              ? (_openBlock(), _createBlock("div", _hoisted_146, [
                                  _createVNode("div", _hoisted_147, [
                                    _withDirectives(_createVNode("input", {
                                      type: "checkbox",
                                      class: "custom-control-input",
                                      id: "guestSwitch1",
                                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.state.data.inviteAsPublicUser = $event))
                                    }, null, 512), [
                                      [_vModelCheckbox, _ctx.state.data.inviteAsPublicUser]
                                    ]),
                                    _createVNode("label", _hoisted_148, _toDisplayString(_ctx.$t('as_public_user')), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      (_ctx.allChannels && _ctx.allChannels.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_149, [
                            _createVNode("label", _hoisted_150, _toDisplayString(_ctx.$t('select_channel')), 1),
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.selectedChannels,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.selectedChannels = $event)),
                              options: _ctx.allChannels,
                              "close-on-select": "true",
                              "clear-on-select": true,
                              placeholder: _ctx.$t('search_and_select'),
                              label: "name",
                              "track-by": "name",
                              onSelect: _cache[32] || (_cache[32] = ($event: any) => (_ctx.selectToChange(_ctx.selectedChannels))),
                              disabled: _ctx.state.ui.modal.selectedFromChannel
                            }, null, 8, ["modelValue", "options", "placeholder", "disabled"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.selectedAllChannel, (channel, channelIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "email-tag",
                                key: channelIndex
                              }, [
                                _createVNode("p", _hoisted_151, [
                                  _createTextVNode(_toDisplayString(channel.name) + " ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedChannel(channel))
                                  }, [
                                    (!_ctx.state.ui.modal.selectedFromChannel)
                                      ? (_openBlock(), _createBlock("i", _hoisted_152))
                                      : _createCommentVNode("", true)
                                  ], 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.state.showCheckChannelMessage)
                        ? (_openBlock(), _createBlock("div", _hoisted_153, [
                            _createVNode("p", _hoisted_154, [
                              _createVNode("small", null, _toDisplayString(_ctx.$t('dont_own_channel')), 1)
                            ]),
                            _createVNode("p", _hoisted_155, [
                              _createVNode("small", null, _toDisplayString(_ctx.$t('start_with_creating_channel')), 1)
                            ]),
                            _createVNode("p", null, [
                              (_ctx.isUserStatus)
                                ? (_openBlock(), _createBlock("a", {
                                    key: 0,
                                    href: "javascript:void(0)",
                                    class: "btn default-btn mt-2",
                                    onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.showCreateProjectChannel && _ctx.showCreateProjectChannel(...args)))
                                  }, [
                                    _hoisted_156,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('create_channel')), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.state.data.inviteAsGuest &&
                    !_ctx.state.data.inviteAsPublicUser && _ctx.state.data.activeMemberList && _ctx.state.data.activeMemberList.length > 1
                  )
                        ? (_openBlock(), _createBlock("div", _hoisted_157, [
                            _createVNode("label", _hoisted_158, _toDisplayString(_ctx.$t('invite_existing_member')), 1),
                            _createVNode(_component_multiselect, {
                              modelValue: _ctx.selectedUsers,
                              "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => (_ctx.selectedUsers = $event)),
                              options: _ctx.state.data.activeMemberList,
                              "custom-label": _ctx.nameWithEmail,
                              "close-on-select": "true",
                              "clear-on-select": true,
                              placeholder: _ctx.$t('search_and_select'),
                              label: "email",
                              "track-by": "email",
                              onSelect: _cache[35] || (_cache[35] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                            }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.users, (user, userIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "email-tag",
                                key: userIndex
                              }, [
                                (user.email && !user.phone)
                                  ? (_openBlock(), _createBlock("p", _hoisted_159, [
                                      _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                      }, [
                                        _hoisted_160
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (user.phone && !user.email)
                                  ? (_openBlock(), _createBlock("p", _hoisted_161, [
                                      _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.phone) + ") ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                      }, [
                                        _hoisted_162
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (user.phone && user.email)
                                  ? (_openBlock(), _createBlock("p", _hoisted_163, [
                                      _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") - (" + _toDisplayString(user.phone) + ") ", 1),
                                      _createVNode("a", {
                                        href: "javascript:void(0)",
                                        onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                                      }, [
                                        _hoisted_164
                                      ], 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (!_ctx.state.data.inviteAsPublicUser)
                        ? (_openBlock(), _createBlock("div", _hoisted_165, [
                            _createVNode("label", _hoisted_166, _toDisplayString(_ctx.$t('invite_new_member')), 1),
                            (_ctx.state.inputError)
                              ? (_openBlock(), _createBlock("p", _hoisted_167, _toDisplayString(_ctx.$t('please_fill_field')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.duplicate)
                              ? (_openBlock(), _createBlock("p", _hoisted_168, _toDisplayString(_ctx.$t('email_already_used')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.invite.invites && _ctx.state.data.invite.invites.length)
                              ? (_openBlock(), _createBlock("div", _hoisted_169, [
                                  _createVNode("table", _hoisted_170, [
                                    _createVNode("thead", _hoisted_171, [
                                      _createVNode("tr", null, [
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('first_name')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('last_name')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('mobile_number')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('email')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('notify_by')), 1),
                                        _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                                      ])
                                    ]),
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                                      return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                        _createVNode("tr", null, [
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_172, [
                                              _withDirectives(_createVNode("input", {
                                                type: "text",
                                                class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                                "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                              }, null, 10, ["onUpdate:modelValue"]), [
                                                [_vModelText, invite.first_name]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_173, [
                                              _withDirectives(_createVNode("input", {
                                                type: "text",
                                                class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                                "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                              }, null, 10, ["onUpdate:modelValue"]), [
                                                [_vModelText, invite.last_name]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_174, [
                                              _createVNode("div", _hoisted_175, [
                                                _createVNode(_component_AppPhoneNumberInput, {
                                                  modelValue: invite.phone,
                                                  "onUpdate:modelValue": ($event: any) => (invite.phone = $event),
                                                  onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'phone'))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_176, [
                                              _withDirectives(_createVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                "onUpdate:modelValue": ($event: any) => (invite.email = $event),
                                                onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'email'))
                                              }, null, 40, ["onUpdate:modelValue", "onInput"]), [
                                                [_vModelText, invite.email]
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", null, [
                                            _createVNode("div", _hoisted_177, [
                                              _createVNode("div", _hoisted_178, [
                                                _createVNode("div", _hoisted_179, [
                                                  _withDirectives(_createVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    id: "inlineCheckbox1",
                                                    value: "true",
                                                    "onUpdate:modelValue": ($event: any) => (invite.mailNotification = $event)
                                                  }, null, 8, ["onUpdate:modelValue"]), [
                                                    [_vModelCheckbox, invite.mailNotification]
                                                  ]),
                                                  _hoisted_180
                                                ]),
                                                _createVNode("div", _hoisted_181, [
                                                  _withDirectives(_createVNode("input", {
                                                    class: "form-check-input",
                                                    type: "checkbox",
                                                    id: "inlineCheckbox2",
                                                    value: "true",
                                                    "onUpdate:modelValue": ($event: any) => (invite.smsNotification = $event)
                                                  }, null, 8, ["onUpdate:modelValue"]), [
                                                    [_vModelCheckbox, invite.smsNotification]
                                                  ]),
                                                  _createVNode("label", _hoisted_182, _toDisplayString(_ctx.$t('sms')), 1)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createVNode("td", _hoisted_183, [
                                            (_ctx.state.data.invite.invites.length === inviteIndex + 1)
                                              ? (_openBlock(), _createBlock("button", {
                                                  key: 0,
                                                  type: "button",
                                                  class: "btn btn-sm text-primary mr-1",
                                                  disabled: !_ctx.hasValidLastContact,
                                                  onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.addNewMember && _ctx.addNewMember(...args)))
                                                }, [
                                                  _hoisted_184,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                                ], 8, ["disabled"]))
                                              : _createCommentVNode("", true),
                                            (_ctx.state.data.invite.invites.length != 1)
                                              ? (_openBlock(), _createBlock("a", {
                                                  key: 1,
                                                  title: "Delete",
                                                  href: "javascript:void(0)",
                                                  class: "btn btn-sm text-danger",
                                                  disabled: _ctx.state.data.invite.invites.length === 1,
                                                  onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                                }, [
                                                  _hoisted_185,
                                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                                ], 8, ["disabled", "onClick"]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    }), 128))
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode("h5", _hoisted_186, _toDisplayString(_ctx.$t('include_conversation_history')), 1),
                            _createVNode("p", _hoisted_187, _toDisplayString(_ctx.$t('conversation_history_description')), 1),
                            _createVNode("div", _hoisted_188, [
                              _createVNode("div", _hoisted_189, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline1",
                                  name: "customRadioInline",
                                  value: "1",
                                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_190, _toDisplayString(_ctx.$t('from_invitation_accepted')), 1)
                              ]),
                              _createVNode("div", _hoisted_191, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline2",
                                  name: "customRadioInline",
                                  value: "2",
                                  "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_192, _toDisplayString(_ctx.$t('from_today')), 1)
                              ]),
                              _createVNode("div", _hoisted_193, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline3",
                                  name: "customRadioInline",
                                  value: "3",
                                  "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_194, _toDisplayString(_ctx.$t('from_the_beginning')), 1)
                              ]),
                              _createVNode("div", _hoisted_195, [
                                _withDirectives(_createVNode("input", {
                                  type: "radio",
                                  id: "customRadioInline4",
                                  name: "customRadioInline",
                                  value: "4",
                                  "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => (_ctx.selectedValue = $event)),
                                  class: "custom-control-input"
                                }, null, 512), [
                                  [_vModelRadio, _ctx.selectedValue]
                                ]),
                                _createVNode("label", _hoisted_196, _toDisplayString(_ctx.$t('custom')), 1)
                              ])
                            ]),
                            (_ctx.selectedValue === '4')
                              ? (_openBlock(), _createBlock("div", _hoisted_197, [
                                  _createVNode("div", _hoisted_198, [
                                    _createVNode("div", _hoisted_199, [
                                      _createVNode(_component_v_date_picker, {
                                        modelValue: _ctx.selectedDateForMember,
                                        "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => (_ctx.selectedDateForMember = $event))
                                      }, null, 8, ["modelValue"])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.state.errorList && _ctx.state.errorList.length && _ctx.state.isErrorStatus)
                              ? (_openBlock(), _createBlock("div", _hoisted_200, [
                                  _hoisted_201,
                                  _hoisted_202
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : (_openBlock(), _createBlock("div", _hoisted_203, [
                            _createVNode("label", _hoisted_204, _toDisplayString(_ctx.$t('invite_new_member_email_number')), 1),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.inviteAsPublic, (publicMember, indexPublicMember) => {
                              return (_openBlock(), _createBlock("div", {
                                class: "row mb-3 align-items-center",
                                key: indexPublicMember
                              }, [
                                _createVNode("div", _hoisted_205, [
                                  _createVNode("div", _hoisted_206, [
                                    _createVNode("label", _hoisted_207, _toDisplayString(_ctx.$t('full_name')), 1),
                                    _withDirectives(_createVNode("input", {
                                      type: "text",
                                      class: "form-control",
                                      id: "exampleFullName",
                                      placeholder: _ctx.$t('your_full_name'),
                                      "onUpdate:modelValue": ($event: any) => (publicMember.name = $event)
                                    }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                                      [_vModelText, publicMember.name]
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_208, [
                                  _createVNode("div", _hoisted_209, [
                                    _createVNode("label", _hoisted_210, _toDisplayString(_ctx.$t('email')), 1),
                                    _withDirectives(_createVNode("input", {
                                      type: "email",
                                      class: "form-control",
                                      id: "exampleEmailInput",
                                      placeholder: "abc@convorally.com",
                                      "onUpdate:modelValue": ($event: any) => (publicMember.email = $event)
                                    }, null, 8, ["onUpdate:modelValue"]), [
                                      [_vModelText, publicMember.email]
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_211, [
                                  _createVNode("div", _hoisted_212, [
                                    _createVNode("label", _hoisted_213, _toDisplayString(_ctx.$t('mobile_number')), 1),
                                    _createVNode("div", _hoisted_214, [
                                      _hoisted_215,
                                      _withDirectives(_createVNode("input", {
                                        type: "number",
                                        class: "form-control",
                                        id: "exampleMobileNumber",
                                        placeholder: _ctx.$t('mobile_number_only'),
                                        "onUpdate:modelValue": ($event: any) => (publicMember.phone = $event)
                                      }, null, 8, ["placeholder", "onUpdate:modelValue"]), [
                                        [_vModelText, publicMember.phone]
                                      ])
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_216, [
                                  _createVNode("label", _hoisted_217, _toDisplayString(_ctx.$t('notify_by')), 1),
                                  _createVNode("div", _hoisted_218, [
                                    _createVNode("div", _hoisted_219, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox1",
                                        value: "false",
                                        "onUpdate:modelValue": ($event: any) => (publicMember.mailNotification = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelCheckbox, publicMember.mailNotification]
                                      ]),
                                      _createVNode("label", _hoisted_220, _toDisplayString(_ctx.$t('email')), 1)
                                    ]),
                                    _createVNode("div", _hoisted_221, [
                                      _withDirectives(_createVNode("input", {
                                        class: "form-check-input",
                                        type: "checkbox",
                                        id: "inlineCheckbox2",
                                        value: "false",
                                        "onUpdate:modelValue": ($event: any) => (publicMember.smsNotification = $event)
                                      }, null, 8, ["onUpdate:modelValue"]), [
                                        [_vModelCheckbox, publicMember.smsNotification]
                                      ]),
                                      _createVNode("label", _hoisted_222, _toDisplayString(_ctx.$t('sms')), 1)
                                    ])
                                  ])
                                ]),
                                _createVNode("div", _hoisted_223, [
                                  (indexPublicMember + 1 ==
                          _ctx.state.inviteAsPublic.length ||
                          _ctx.state.inviteAsPublic.length === 1
                        )
                                    ? (_openBlock(), _createBlock("button", {
                                        key: 0,
                                        class: "btn default-btn mr-1",
                                        onClick: _cache[42] || (_cache[42] = 
//@ts-ignore
(...args) => (_ctx.changeInvitePublicMember && _ctx.changeInvitePublicMember(...args)))
                                      }, [
                                        _hoisted_224,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (_ctx.state.inviteAsPublic &&
                          _ctx.state.inviteAsPublic.length > 1
                        )
                                    ? (_openBlock(), _createBlock("a", {
                                        key: 1,
                                        class: "btn btn-danger",
                                        onClick: ($event: any) => (_ctx.deletePublicMember(publicMember)),
                                        href: "javascript:void(0)"
                                      }, [
                                        _hoisted_225,
                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                      ], 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            }), 128)),
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                              return (_openBlock(), _createBlock("div", {
                                key: inviteIndex,
                                class: "email-tag"
                              }, [
                                _createVNode("p", _hoisted_226, [
                                  _createTextVNode(_toDisplayString(invite) + " ", 1),
                                  _createVNode("a", {
                                    href: "javascript:void(0)",
                                    onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                  }, [
                                    _hoisted_227,
                                    _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                  ], 8, ["onClick"])
                                ])
                              ]))
                            }), 128))
                          ]))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_228, [
              _createVNode("div", null, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn secondary-btn mr-2",
                  onClick: _cache[43] || (_cache[43] = 
//@ts-ignore
(...args) => (_ctx.hideAddMember && _ctx.hideAddMember(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1),
                (_ctx.state.data.inviteAsPublicUser)
                  ? (_openBlock(), _createBlock("a", {
                      key: 0,
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[44] || (_cache[44] = 
//@ts-ignore
(...args) => (_ctx.inviteAllPublicUser && _ctx.inviteAllPublicUser(...args)))
                    }, _toDisplayString(_ctx.$t('send')), 1))
                  : (_openBlock(), _createBlock("a", {
                      key: 1,
                      href: "javascript:void(0)",
                      class: "btn default-btn",
                      onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.inviteAllUsers && _ctx.inviteAllUsers(...args)))
                    }, _toDisplayString(_ctx.state.ui.isPostLoading.inviteAllUsers ? _ctx.$t('sending') : _ctx.$t('send')), 1))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_229, [
      _createVNode("div", _hoisted_230, [
        _createVNode("div", _hoisted_231, [
          _createVNode("div", _hoisted_232, [
            _createVNode("div", _hoisted_233, [
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessInvitationModal && _ctx.hideSuccessInvitationModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_234
              ]),
              _hoisted_235
            ]),
            _createVNode("div", _hoisted_236, [
              _createVNode("h3", null, _toDisplayString(_ctx.$t('great')), 1),
              _createVNode("p", null, _toDisplayString(_ctx.state.data.invitationMessage), 1),
              _createVNode("p", null, _toDisplayString(_ctx.$t('go_to_channels')), 1)
            ]),
            _createVNode("div", _hoisted_237, [
              _createVNode("a", {
                href: "javascript:void(0)",
                class: "btn default-btn outline",
                onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args)))
              }, _toDisplayString(_ctx.$t('invite_more_people')), 1),
              _createVNode("a", {
                href: "javascript:void(0)",
                onClick: _cache[48] || (_cache[48] = 
//@ts-ignore
(...args) => (_ctx.hideSuccessInvitationModal && _ctx.hideSuccessInvitationModal(...args))),
                class: "btn default-btn outline danger to-upper",
                "data-dismiss": "modal"
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_238, [
      _createVNode("div", _hoisted_239, [
        _createVNode("div", _hoisted_240, [
          _createVNode("div", _hoisted_241, [
            _createVNode("div", _hoisted_242, [
              _createVNode("h5", _hoisted_243, _toDisplayString(_ctx.$t('pin_to_top')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[49] || (_cache[49] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectClose && _ctx.addFavProjectClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_244
              ])
            ]),
            _createVNode("div", _hoisted_245, [
              _createVNode("div", _hoisted_246, _toDisplayString(_ctx.$t('pin_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_247, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[50] || (_cache[50] = 
//@ts-ignore
(...args) => (_ctx.projectFav && _ctx.projectFav(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.projectFav ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.addFavProjectClose && _ctx.addFavProjectClose(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_248, [
      _createVNode("div", _hoisted_249, [
        _createVNode("div", _hoisted_250, [
          _createVNode("div", _hoisted_251, [
            _createVNode("div", _hoisted_252, [
              _createVNode("h5", _hoisted_253, _toDisplayString(_ctx.$t('unpin_project')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectClose && _ctx.removeFavProjectClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_254
              ])
            ]),
            _createVNode("div", _hoisted_255, [
              _createVNode("div", _hoisted_256, _toDisplayString(_ctx.$t('unpin_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_257, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.projectFavRemove && _ctx.projectFavRemove(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.projectFavRemove ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[54] || (_cache[54] = 
//@ts-ignore
(...args) => (_ctx.removeFavProjectClose && _ctx.removeFavProjectClose(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_258, [
      _createVNode("div", _hoisted_259, [
        _createVNode("div", _hoisted_260, [
          _createVNode("div", _hoisted_261, [
            _createVNode("div", _hoisted_262, [
              _createVNode("h5", _hoisted_263, _toDisplayString(_ctx.$t('edit_channel')) + " : " + _toDisplayString(_ctx.state.data.selectedChannel.name), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.hideEditChannelModal && _ctx.hideEditChannelModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_264
              ])
            ]),
            _createVNode("div", _hoisted_265, [
              _createVNode("div", _hoisted_266, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.errors.errorList.saveEditChannel,
                  hasError: _ctx.state.ui.errors.hasError
                }, null, 8, ["errors", "hasError"])
              ]),
              _createVNode("div", _hoisted_267, [
                _createVNode("label", _hoisted_268, [
                  _createTextVNode(_toDisplayString(_ctx.$t('channel_name')) + " ", 1),
                  _hoisted_269
                ]),
                _withDirectives(_createVNode("input", {
                  type: "input",
                  class: "form-control",
                  id: "exampleInput",
                  "aria-describedby": "emailHelp",
                  placeholder: _ctx.$t('channel_name'),
                  "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => (_ctx.state.data.selectedEditChannel.name = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.selectedEditChannel.name]
                ])
              ]),
              _createVNode("div", _hoisted_270, [
                _createVNode("label", _hoisted_271, _toDisplayString(_ctx.$t('channel_description1')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "5",
                  placeholder: _ctx.$t('describe_channel'),
                  "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => (_ctx.state.data.selectedEditChannel.description = $event))
                }, null, 8, ["placeholder"]), [
                  [_vModelText, _ctx.state.data.selectedEditChannel.description]
                ])
              ])
            ]),
            _createVNode("div", _hoisted_272, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.saveEditChannel && _ctx.saveEditChannel(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEditChannel
                ? _ctx.$t('loading1')
                : _ctx.$t('save_changes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn to-upper",
                "data-dismiss": "modal",
                onClick: _cache[59] || (_cache[59] = 
//@ts-ignore
(...args) => (_ctx.hideEditChannelModal && _ctx.hideEditChannelModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.data.showEditChannelModal]
    ]),
    _withDirectives(_createVNode("div", _hoisted_273, [
      _createVNode("div", _hoisted_274, [
        _createVNode("div", _hoisted_275, [
          _createVNode("div", _hoisted_276, [
            _createVNode("div", _hoisted_277, [
              _createVNode("h5", _hoisted_278, _toDisplayString(_ctx.$t('hide_channel')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[60] || (_cache[60] = 
//@ts-ignore
(...args) => (_ctx.hideChannelClose && _ctx.hideChannelClose(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_279
              ])
            ]),
            _createVNode("div", _hoisted_280, [
              _createVNode("div", _hoisted_281, _toDisplayString(_ctx.$t('hide_confirmation')), 1)
            ]),
            _createVNode("div", _hoisted_282, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn",
                onClick: _cache[61] || (_cache[61] = 
//@ts-ignore
(...args) => (_ctx.channelHide && _ctx.channelHide(...args)))
              }, _toDisplayString(_ctx.state.ui.isPostLoading.projectHide ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[62] || (_cache[62] = 
//@ts-ignore
(...args) => (_ctx.hideChannelClose && _ctx.hideChannelClose(...args)))
              }, _toDisplayString(_ctx.$t('no')), 1)
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.data.showHideChannelModal]
    ]),
    _createVNode("div", _hoisted_283, [
      _createVNode("div", _hoisted_284, [
        _createVNode("div", _hoisted_285, [
          _createVNode("div", _hoisted_286, [
            _createVNode("div", _hoisted_287, [
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("h5", _hoisted_288, _toDisplayString(_ctx.$t('edit')) + " : " + _toDisplayString(_ctx.state.data.selectedProject.name), 1))
                : (_openBlock(), _createBlock("h5", _hoisted_289, _toDisplayString(_ctx.state.data.selectedProject.name), 1)),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[63] || (_cache[63] = 
//@ts-ignore
(...args) => (_ctx.hideRenameProjectModal && _ctx.hideRenameProjectModal(...args))),
                "aria-label": "Close"
              })
            ]),
            _createVNode("div", _hoisted_290, [
              _createVNode("div", _hoisted_291, [
                (!_ctx.isEdit && _ctx.isUserStatus && _ctx.state.data.projectDetail.project.status_id !== 2)
                  ? (_openBlock(), _createBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn default-btn",
                      onClick: _cache[64] || (_cache[64] = 
//@ts-ignore
(...args) => (_ctx.checkEdit && _ctx.checkEdit(...args)))
                    }, [
                      _hoisted_292,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('edit_details')), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("p", _hoisted_293, [
                    _createTextVNode(_toDisplayString(_ctx.$t('note')) + " " + _toDisplayString(_ctx.$t('fields_marked_with')) + " ", 1),
                    _hoisted_294,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('are_mandatory')), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.ui.successMessage && !_ctx.isEdit)
                ? (_openBlock(), _createBlock("div", _hoisted_295, _toDisplayString(_ctx.state.ui.successMessage), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_ErrorList, {
                errors: _ctx.state.ui.errors.errorList.saveEditProject,
                hasError: _ctx.state.ui.errors.hasError
              }, null, 8, ["errors", "hasError"]),
              _createVNode("div", _hoisted_296, [
                _createVNode("label", _hoisted_297, [
                  _createTextVNode(_toDisplayString(_ctx.$t('project_name')) + " ", 1),
                  (_ctx.isEdit)
                    ? (_openBlock(), _createBlock("span", _hoisted_298, "*"))
                    : _createCommentVNode("", true)
                ]),
                _withDirectives(_createVNode("input", {
                  type: "email",
                  class: "form-control",
                  id: "exampleInputEmail1",
                  "aria-describedby": "emailHelp",
                  placeholder: _ctx.$t('project_name_placeholder'),
                  "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => (_ctx.state.data.selectedProjectEdit.projectName = $event)),
                  disabled: !_ctx.isEdit
                }, null, 8, ["placeholder", "disabled"]), [
                  [_vModelText, _ctx.state.data.selectedProjectEdit.projectName]
                ])
              ]),
              _createVNode("div", _hoisted_299, [
                _createVNode("label", _hoisted_300, _toDisplayString(_ctx.$t('project_description')), 1),
                _withDirectives(_createVNode("textarea", {
                  class: "form-control",
                  name: "",
                  id: "",
                  cols: "30",
                  rows: "5",
                  placeholder: _ctx.$t('project_description_placeholder'),
                  "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => (_ctx.state.data.selectedProjectEdit.projectDescription = $event)),
                  disabled: !_ctx.isEdit
                }, null, 8, ["placeholder", "disabled"]), [
                  [_vModelText, _ctx.state.data.selectedProjectEdit.projectDescription]
                ])
              ]),
              _createVNode("div", _hoisted_301, [
                _createVNode("label", _hoisted_302, _toDisplayString(_ctx.$t('project_tags')), 1),
                _createVNode(_component_multiselect, {
                  modelValue: _ctx.selectedOptions,
                  "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => (_ctx.selectedOptions = $event)),
                  "tag-placeholder": "Add this as new tag",
                  placeholder: _ctx.$t('project_tags_placeholder'),
                  label: "name",
                  "track-by": "code",
                  options: _ctx.options,
                  multiple: true,
                  taggable: true,
                  onTag: _ctx.addTag,
                  disabled: !_ctx.isEdit
                }, null, 8, ["modelValue", "placeholder", "options", "onTag", "disabled"])
              ]),
              _createVNode("div", _hoisted_303, [
                _createVNode("label", _hoisted_304, _toDisplayString(_ctx.$t('project_address')), 1),
                _createVNode(_component_GoogleMapView, {
                  latitude: _ctx.latitude,
                  longitude: _ctx.longitude,
                  address: _ctx.address,
                  isEdit: _ctx.isEdit,
                  "onUpdate:latitude": _ctx.updateLatitude,
                  "onUpdate:longitude": _ctx.updateLongitude,
                  "onUpdate:address": _ctx.updateAddress,
                  key: _ctx.latitude
                }, null, 8, ["latitude", "longitude", "address", "isEdit", "onUpdate:latitude", "onUpdate:longitude", "onUpdate:address"])
              ])
            ]),
            _createVNode("div", _hoisted_305, [
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock("button", {
                    key: 0,
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.saveEditProject && _ctx.saveEditProject(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.saveEditProject
                ? _ctx.$t('loading1')
                : _ctx.$t('save_changes')), 1))
                : _createCommentVNode("", true),
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.hideRenameProjectModal && _ctx.hideRenameProjectModal(...args)))
              }, _toDisplayString(_ctx.$t('close')), 1)
            ])
          ])
        ])
      ])
    ]),
    _withDirectives(_createVNode("div", _hoisted_306, [
      _createVNode("div", _hoisted_307, [
        _createVNode("div", _hoisted_308, [
          _createVNode("div", _hoisted_309, [
            _createVNode("div", _hoisted_310, [
              _hoisted_311,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberModal && _ctx.hidePendingMemberModal(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_312
              ])
            ]),
            (_ctx.state.data.pendingList && _ctx.state.data.pendingList.length)
              ? (_openBlock(), _createBlock("div", _hoisted_313, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.resendInvitation,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.pendingList, (member, pendingMemberIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "row align-items-center",
                      key: pendingMemberIndex
                    }, [
                      _createVNode("div", _hoisted_314, [
                        _createVNode("div", _hoisted_315, [
                          _createVNode("div", _hoisted_316, [
                            (member.user && member.user.image)
                              ? (_openBlock(), _createBlock("img", {
                                  key: 0,
                                  src: member.user.image,
                                  alt: ""
                                }, null, 8, ["src"]))
                              : (_openBlock(), _createBlock("img", {
                                  key: 1,
                                  src: _ctx.state.data.imageBaseUrl
                        ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                        : 'img/no-user.jpg'
                        ,
                                  alt: ""
                                }, null, 8, ["src"]))
                          ]),
                          member
                            ? (_openBlock(), _createBlock("div", _hoisted_317, [
                                _createTextVNode(_toDisplayString(member.first_name) + " " + _toDisplayString(member.last_name) + " ", 1),
                                (member.email || member.mobile)
                                  ? (_openBlock(), _createBlock("div", _hoisted_318, [
                                      _hoisted_319,
                                      (member.email)
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(member.email), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (member.email && member.mobile)
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                            _hoisted_320
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      (member.mobile)
                                        ? (_openBlock(), _createBlock(_Fragment, { key: 2 }, [
                                            _createTextVNode(_toDisplayString(member.mobile), 1)
                                          ], 64))
                                        : _createCommentVNode("", true),
                                      _hoisted_321
                                    ]))
                                  : _createCommentVNode("", true),
                                member
                                  ? (_openBlock(), _createBlock("span", {
                                      key: 1,
                                      class: "info-icon",
                                      onMouseenter: ($event: any) => (_ctx.activeTooltipIndex = pendingMemberIndex),
                                      onMouseleave: _cache[71] || (_cache[71] = ($event: any) => (_ctx.activeTooltipIndex = null))
                                    }, [
                                      _hoisted_322
                                    ], 40, ["onMouseenter"]))
                                  : _createCommentVNode("", true),
                                (_ctx.activeTooltipIndex === pendingMemberIndex)
                                  ? (_openBlock(), _createBlock("div", _hoisted_323, [
                                      _createVNode("p", null, "Validity: " + _toDisplayString(_ctx.formatValidity(member.validity, member.invitation_validity)), 1),
                                      _createVNode("p", null, "Chat History: " + _toDisplayString(_ctx.formatChatHistory(member.message_share_type, member.message_share_date, member.created_date)), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (_ctx.isUserStatus && member.statusCode === 'Active' && _ctx.state.data.projectDetail.project.status_id !== 2)
                        ? (_openBlock(), _createBlock("div", _hoisted_324, [
                            _createVNode("a", {
                              class: "btn default-btn outline orange p-1 mr-2",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.selectPendingMemberForDeletes(member))
                            }, [
                              _hoisted_325
                            ], 8, ["onClick"]),
                            _createVNode("a", {
                              class: "btn default-btn outline p-1",
                              href: "javascript:void(0)",
                              onClick: ($event: any) => (_ctx.showResendInvitationConfirmation(member))
                            }, [
                              _hoisted_326
                            ], 8, ["onClick"])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode("div", _hoisted_327, [
              _createVNode("button", {
                type: "button",
                class: "btn secondary-btn",
                "data-dismiss": "modal",
                onClick: _cache[72] || (_cache[72] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberModal && _ctx.hidePendingMemberModal(...args)))
              }, " Close ")
            ])
          ])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.data.showPendingMemberModal]
    ]),
    _withDirectives(_createVNode("div", _hoisted_328, [
      _createVNode("div", _hoisted_329, [
        _createVNode("div", _hoisted_330, [
          (_ctx.state.data.selectedPendingMember)
            ? (_openBlock(), _createBlock("div", _hoisted_331, [
                _createVNode("div", _hoisted_332, [
                  (_ctx.state.data.selectedPendingMember)
                    ? (_openBlock(), _createBlock("h5", _hoisted_333, " reinvite " + _toDisplayString(_ctx.state.data.selectedPendingMember.email) + "? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[73] || (_cache[73] = 
//@ts-ignore
(...args) => (_ctx.hideResendInvitationConfirmation && _ctx.hideResendInvitationConfirmation(...args)))
                  }, [
                    _hoisted_334
                  ])
                ]),
                (_ctx.state.data.selectedPendingMember.email)
                  ? (_openBlock(), _createBlock("div", _hoisted_335, [
                      _hoisted_336,
                      _createVNode("div", _hoisted_337, [
                        _createVNode("ul", null, [
                          _createVNode("li", null, _toDisplayString(_ctx.state.data.selectedPendingMember.email) + " will be invited again. ", 1)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_338, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    onClick: _cache[74] || (_cache[74] = 
//@ts-ignore
(...args) => (_ctx.hideResendInvitationConfirmation && _ctx.hideResendInvitationConfirmation(...args)))
                  }, " Cancel "),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[75] || (_cache[75] = 
//@ts-ignore
(...args) => (_ctx.resendInvitation && _ctx.resendInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.resendInvitation
                ? "Reinviting..."
                : "Yes,invite user."), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.data.showResendInvitationPendingMember]
    ]),
    _withDirectives(_createVNode("div", _hoisted_339, [
      _createVNode("div", _hoisted_340, [
        _createVNode("div", _hoisted_341, [
          (_ctx.state.data.selectedPendingMember)
            ? (_openBlock(), _createBlock("div", _hoisted_342, [
                _createVNode("div", _hoisted_343, [
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[76] || (_cache[76] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberRemove && _ctx.hidePendingMemberRemove(...args)))
                  }, [
                    _hoisted_344
                  ])
                ]),
                _createVNode("div", _hoisted_345, [
                  _createVNode("div", _hoisted_346, [
                    (_ctx.state.data.selectedPendingMember)
                      ? (_openBlock(), _createBlock("p", _hoisted_347, [
                          _hoisted_348,
                          _createVNode("strong", null, [
                            _createTextVNode(_toDisplayString(_ctx.state.data.selectedPendingMember.first_name) + " " + _toDisplayString(_ctx.state.data.selectedPendingMember.last_name) + " ", 1),
                            (_ctx.state.data.selectedPendingMember.email)
                              ? (_openBlock(), _createBlock("span", _hoisted_349, "(" + _toDisplayString(_ctx.state.data.selectedPendingMember.email) + ")", 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.selectedPendingMember.contact_number)
                              ? (_openBlock(), _createBlock("span", _hoisted_350, "(" + _toDisplayString(_ctx.state.data.selectedPendingMember.contact_number) + ")", 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createVNode("div", _hoisted_351, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    onClick: _cache[77] || (_cache[77] = 
//@ts-ignore
(...args) => (_ctx.hidePendingMemberRemove && _ctx.hidePendingMemberRemove(...args)))
                  }, " Cancel "),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[78] || (_cache[78] = 
//@ts-ignore
(...args) => (_ctx.deletePendingInvitation && _ctx.deletePendingInvitation(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.deletePendingInvitation
                ? "Removing..."
                : "Yes,remove user."), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, _ctx.state.data.showRemovePendingMember]
    ]),
    _createVNode("div", {
      class: ["custom-sidebar", { 'open': _ctx.activeSidebar === 'sidebar-members' }]
    }, [
      _createVNode("div", _hoisted_352, [
        _createVNode("h5", _hoisted_353, [
          _hoisted_354,
          (_ctx.state.data.activeMemberList && _ctx.state.data.activeMemberList.length)
            ? (_openBlock(), _createBlock("span", _hoisted_355, "(" + _toDisplayString(_ctx.state.data.activeMemberList.length) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _createVNode("button", {
          type: "button",
          class: "btn-close text-reset",
          onClick: _cache[79] || (_cache[79] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
          "aria-label": "Close"
        }, "close")
      ]),
      _createVNode("div", _hoisted_356, [
        _createVNode("div", _hoisted_357, [
          _createVNode("div", _hoisted_358, [
            _createVNode("div", _hoisted_359, [
              _createVNode("ul", null, [
                _createVNode("li", _hoisted_360, [
                  (_ctx.isUserStatus && _ctx.state.data.projectDetail.project.status_id !== 2)
                    ? (_openBlock(), _createBlock("a", {
                        key: 0,
                        href: "javascript:void(0)",
                        class: "default-btn p-2",
                        onClick: _cache[80] || (_cache[80] = 
//@ts-ignore
(...args) => (_ctx.addMember && _ctx.addMember(...args))),
                        id: "addMember"
                      }, [
                        _hoisted_361,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('add_member')), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.activeMemberList, (member, memderIndex) => {
            return (_openBlock(), _createBlock("div", {
              class: "member-list member-chat",
              key: memderIndex
            }, [
              member
                ? (_openBlock(), _createBlock("div", _hoisted_362, [
                    (member.image)
                      ? (_openBlock(), _createBlock("img", {
                          key: 0,
                          src: member.image,
                          alt: member.full_name,
                          title: member.full_name
                        }, null, 8, ["src", "alt", "title"]))
                      : (_openBlock(), _createBlock("img", {
                          key: 1,
                          src: _ctx.state.data.imageBaseUrl
                ? `${_ctx.state.data.imageBaseUrl}img/no-user.jpg`
                : 'img/no-user.jpg'
                ,
                          alt: member.full_name,
                          title: member.full_name
                        }, null, 8, ["src", "alt", "title"]))
                  ]))
                : _createCommentVNode("", true),
              (member && member.full_name)
                ? (_openBlock(), _createBlock("h5", _hoisted_363, [
                    _createTextVNode(_toDisplayString(member.full_name) + " - ", 1),
                    _createVNode("span", _hoisted_364, _toDisplayString(member.role), 1)
                  ]))
                : _createCommentVNode("", true),
              (member.added_at)
                ? (_openBlock(), _createBlock("span", _hoisted_365, [
                    _hoisted_366,
                    _createTextVNode(" " + _toDisplayString(member.convertedDateTime), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.state.data.projectDetail.project.status_id !== 2)
                ? (_openBlock(), _createBlock("div", _hoisted_367, [
                    ((_ctx.state.data.activeUserEmail != member.email &&
                _ctx.isUserStatus) ||
                (_ctx.state.data.activeUserEmail != member.email &&
                  !_ctx.isUserStatus &&
                  member.role_code != 'todo_payer')
              )
                      ? (_openBlock(), _createBlock("a", {
                          key: 0,
                          class: "btn btn-sm default-btn outline mr-2",
                          onClick: ($event: any) => (_ctx.privateChat(member)),
                          href: "javascript:void(0)",
                          title: "Private chat"
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.$t('chat')) + " ", 1),
                          _hoisted_368
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (member.isChangeRole &&
                _ctx.isUserStatus &&
                member.role_code != 'guest_user' &&
                member.role_code != 'todo_payer' &&
                member.role_code != 'todo_subcontractor' &&
                member.role_code != 'todo_member' && 
                member.role_code != 'estimation_member' &&
                member.role_code !== 'owner'
              )
                      ? (_openBlock(), _createBlock("a", {
                          key: 1,
                          title: "Change Role",
                          class: "btn default-btn btn-sm mr-2",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.changeRole(member))
                        }, [
                          _hoisted_369
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    (member.isChangeRole &&               
               _ctx.isUserStatus &&
                member.role_code != 'todo_payer' &&
                member.role_code != 'todo_subcontractor' &&
                member.role_code != 'todo_member' && 
                member.role_code != 'estimation_member' &&
                member.role_code !== 'owner'
              )
                      ? (_openBlock(), _createBlock("a", {
                          key: 2,
                          title: "Remove Member From Channel",
                          class: "btn default-btn btn-sm mr-2",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.memberChannelList(member))
                        }, [
                          _hoisted_370
                        ], 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ], 2),
    _createVNode("div", {
      class: ["custom-sidebar", { 'open': _ctx.activeSidebar === 'sidebar-history' }]
    }, [
      _createVNode("div", _hoisted_371, [
        _hoisted_372,
        _createVNode("button", {
          type: "button",
          class: "btn-close text-reset",
          onClick: _cache[81] || (_cache[81] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
          "aria-label": "Close"
        }, "close")
      ]),
      _createVNode("div", _hoisted_373, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.activityList, (activity, activityIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "activity-list",
            key: activityIndex
          }, [
            _createVNode("div", _hoisted_374, [
              _createVNode("img", {
                src: activity.activity_by.image,
                alt: ""
              }, null, 8, ["src"])
            ]),
            _createVNode("p", null, _toDisplayString(activity.description), 1)
          ]))
        }), 128))
      ])
    ], 2),
    _createVNode("div", {
      class: ["custom-sidebar", { 'open': _ctx.activeSidebar === 'sidebar-latest-forms' }]
    }, [
      _createVNode("div", _hoisted_375, [
        _hoisted_376,
        _createVNode("button", {
          type: "button",
          class: "btn-close text-reset",
          onClick: _cache[82] || (_cache[82] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
          "aria-label": "Close"
        }, "close")
      ]),
      _createVNode("div", _hoisted_377, [
        _createVNode("div", _hoisted_378, [
          _withDirectives(_createVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => (_ctx.state.data.searchBy = $event)),
            onKeyup: _cache[84] || (_cache[84] = 
//@ts-ignore
(...args) => (_ctx.getAccountFormList && _ctx.getAccountFormList(...args)))
          }, null, 544), [
            [_vModelText, _ctx.state.data.searchBy]
          ]),
          _hoisted_379
        ])
      ]),
      (_ctx.state.ui.isPostLoading.getAccountFormList)
        ? (_openBlock(), _createBlock("span", _hoisted_380, [
            _hoisted_381
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_382, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.templateList.slice(
          0,
          5
        ), (template, templateIndex) => {
              return (_openBlock(), _createBlock(_component_TemplateCard, {
                template: template,
                key: templateIndex,
                isUserStatus: _ctx.isUserStatus
              }, null, 8, ["template", "isUserStatus"]))
            }), 128)),
            _createVNode("div", _hoisted_383, [
              _createVNode("a", _hoisted_384, [
                _createVNode(_component_router_link, { to: { name: 'admin-project-forms' } }, {
                  default: _withId(() => [
                    _hoisted_385,
                    _hoisted_386
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
    ], 2),
    _createVNode("div", {
      class: ["custom-sidebar", { 'open': _ctx.activeSidebar === 'sidebar-share-members' }]
    }, [
      _createVNode("div", _hoisted_387, [
        _hoisted_388,
        _createVNode("button", {
          type: "button",
          class: "btn-close text-reset",
          onClick: _cache[85] || (_cache[85] = 
//@ts-ignore
(...args) => (_ctx.closeSidebar && _ctx.closeSidebar(...args))),
          "aria-label": "Close"
        }, "close")
      ]),
      _createVNode("div", _hoisted_389, [
        _createVNode("div", _hoisted_390, [
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn outline",
            onClick: _cache[86] || (_cache[86] = 
//@ts-ignore
(...args) => (_ctx.goToShareInvitation && _ctx.goToShareInvitation(...args)))
          }, "Add Share Project")
        ]),
        _createVNode("div", _hoisted_391, [
          _createVNode("table", _hoisted_392, [
            _createVNode("thead", _hoisted_393, [
              _createVNode("tr", null, [
                _createVNode("td", null, _toDisplayString(_ctx.$t('email')), 1),
                _createVNode("td", null, _toDisplayString(_ctx.$t('status')), 1),
                _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
              ])
            ]),
            (_ctx.state.data.projectShares && _ctx.state.data.projectShares.length)
              ? (_openBlock(), _createBlock("tbody", _hoisted_394, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.projectShares, (share, shareIndex) => {
                    return (_openBlock(), _createBlock("tr", { key: shareIndex }, [
                      _createVNode("td", null, _toDisplayString(share.email), 1),
                      _createVNode("td", null, [
                        (share.is_complete === 0 && share.partial === 0 && share.is_declined === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_395, "Pending"))
                          : _createCommentVNode("", true),
                        (share.is_complete === 0 && share.partial === 1 && share.is_declined === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_396, "Partial"))
                          : _createCommentVNode("", true),
                        (share.is_complete === 0 && share.partial === 0 && share.is_declined === 1
                  )
                          ? (_openBlock(), _createBlock("span", _hoisted_397, _toDisplayString(_ctx.$t('declined')), 1))
                          : _createCommentVNode("", true),
                        (share.is_complete === 1 && share.partial === 0 && share.is_declined === 0)
                          ? (_openBlock(), _createBlock("span", _hoisted_398, "Completed"))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode("td", null, [
                        _createVNode("a", {
                          class: "btn default-btn btn-sm",
                          title: "{{$t('view') }}",
                          onClick: ($event: any) => (_ctx.shareProjectInvitationDetails(share.id)),
                          href: "javascript:void(\n                            0)"
                        }, [
                          _hoisted_399
                        ], 8, ["onClick"]),
                        _createVNode("a", {
                          class: "btn default-btn btn-sm",
                          title: "{{ $t('edit') }}",
                          onClick: ($event: any) => (_ctx.goToShareInvitationEdit(share.id)),
                          href: "javascript:void(\n                            0)"
                        }, [
                          _hoisted_400
                        ], 8, ["onClick"]),
                        _createVNode("a", {
                          class: "btn red-btn btn-sm",
                          title: "{{ $t('delete') }}",
                          href: "javascript:void(0)",
                          onClick: ($event: any) => (_ctx.selectShareProjectRemove(share))
                        }, [
                          _hoisted_401
                        ], 8, ["onClick"])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createBlock("div", _hoisted_402, [
                  _createVNode(_component_EmptyData, {
                    title: _ctx.state.data.titleProjectShare,
                    heading: _ctx.state.data.headingProjectShare
                  }, null, 8, ["title", "heading"])
                ]))
          ])
        ])
      ])
    ], 2),
    _createVNode("div", _hoisted_403, [
      _createVNode("div", _hoisted_404, [
        (_ctx.state.ui.isPostLoading.createPrivateChannelGroup)
          ? (_openBlock(), _createBlock("div", _hoisted_405, [
              _hoisted_406
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_407, [
          _createVNode("div", _hoisted_408, [
            _createVNode("div", _hoisted_409, [
              _createVNode("div", _hoisted_410, [
                _createVNode("h5", _hoisted_411, _toDisplayString(_ctx.$t('create_private_group')), 1),
                _createVNode("p", _hoisted_412, _toDisplayString(_ctx.$t('create_project_collaboration')), 1)
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[87] || (_cache[87] = 
//@ts-ignore
(...args) => (_ctx.hidePrivateChannel && _ctx.hidePrivateChannel(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_413
              ])
            ]),
            _createVNode("div", _hoisted_414, [
              _createVNode("div", _hoisted_415, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.errors.errorList.createPrivateChannelValidation,
                  hasError: _ctx.state.ui.errors.hasError
                }, null, 8, ["errors", "hasError"]),
                (!_ctx.state.data.invitationVerify.showStatus)
                  ? (_openBlock(), _createBlock("div", _hoisted_416, [
                      (_ctx.state.data.selectPrivateChannel)
                        ? (_openBlock(), _createBlock("div", _hoisted_417, [
                            _createVNode("label", _hoisted_418, _toDisplayString(_ctx.$t('invite_channel')), 1),
                            _createVNode("div", _hoisted_419, [
                              _createVNode("p", _hoisted_420, _toDisplayString(_ctx.state.data.selectPrivateChannel.name), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createVNode("div", _hoisted_421, [
                        _createVNode("label", _hoisted_422, _toDisplayString(_ctx.$t('create_channel_with_member')), 1),
                        _createVNode(_component_multiselect, {
                          modelValue: _ctx.selectedUsers,
                          "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => (_ctx.selectedUsers = $event)),
                          options: _ctx.state.data.activeMemberList,
                          "close-on-select": "true",
                          "custom-label": _ctx.nameWithEmail,
                          "clear-on-select": true,
                          placeholder: _ctx.$t('search_and_select'),
                          label: "email",
                          "track-by": "email",
                          onSelect: _cache[89] || (_cache[89] = ($event: any) => (_ctx.selectToChangeUsers(_ctx.selectedUsers)))
                        }, null, 8, ["modelValue", "options", "custom-label", "placeholder"]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.users, (user, userIndex) => {
                          return (_openBlock(), _createBlock("div", {
                            class: "email-tag",
                            key: userIndex
                          }, [
                            _createVNode("p", _hoisted_423, [
                              _createTextVNode(_toDisplayString(user.full_name) + " (" + _toDisplayString(user.email) + ") ", 1),
                              _createVNode("a", {
                                href: "javascript:void(0)",
                                onClick: ($event: any) => (_ctx.removeSelectedMember(user))
                              }, [
                                _hoisted_424
                              ], 8, ["onClick"])
                            ])
                          ]))
                        }), 128))
                      ]),
                      (_ctx.state.inputError)
                        ? (_openBlock(), _createBlock("p", _hoisted_425, _toDisplayString(_ctx.$t('please_fill_field')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.duplicate)
                        ? (_openBlock(), _createBlock("p", _hoisted_426, _toDisplayString(_ctx.$t('email_already_used')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.data.invite.invites && _ctx.state.data.invite.invites.length)
                        ? (_openBlock(), _createBlock("div", _hoisted_427, [
                            _createVNode("table", _hoisted_428, [
                              _createVNode("thead", _hoisted_429, [
                                _createVNode("tr", null, [
                                  _createVNode("td", _hoisted_430, _toDisplayString(_ctx.$t('email')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('mobile_number')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('first_name')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('last_name')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('notify_by')), 1),
                                  _createVNode("td", null, _toDisplayString(_ctx.$t('action')), 1)
                                ])
                              ]),
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite.invites, (invite, inviteIndex) => {
                                return (_openBlock(), _createBlock("tbody", { key: inviteIndex }, [
                                  _createVNode("tr", null, [
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_431, [
                                        _withDirectives(_createVNode("input", {
                                          type: "email",
                                          class: "form-control",
                                          "onUpdate:modelValue": ($event: any) => (invite.email = $event)
                                        }, null, 8, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.email]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_432, [
                                        _createVNode("div", _hoisted_433, [
                                          _createVNode(_component_AppPhoneNumberInput, {
                                            modelValue: invite.phone,
                                            "onUpdate:modelValue": ($event: any) => (invite.phone = $event),
                                            onInput: ($event: any) => (_ctx.checkEmptyFields(inviteIndex, 'phone'))
                                          }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_434, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: invite.fNameError ? 'form-control error-field' : 'form-control',
                                          "onUpdate:modelValue": ($event: any) => (invite.first_name = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.first_name]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_435, [
                                        _withDirectives(_createVNode("input", {
                                          type: "text",
                                          class: invite.lNameError ? 'form-control error-field' : 'form-control',
                                          "onUpdate:modelValue": ($event: any) => (invite.last_name = $event)
                                        }, null, 10, ["onUpdate:modelValue"]), [
                                          [_vModelText, invite.last_name]
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      _createVNode("div", _hoisted_436, [
                                        _createVNode("div", _hoisted_437, [
                                          _createVNode("div", _hoisted_438, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: "inlineCheckbox1",
                                              value: "true",
                                              disabled: invite.mailDisable,
                                              "onUpdate:modelValue": ($event: any) => (invite.mailNotification = $event)
                                            }, null, 8, ["disabled", "onUpdate:modelValue"]), [
                                              [_vModelCheckbox, invite.mailNotification]
                                            ]),
                                            _hoisted_439
                                          ]),
                                          _createVNode("div", _hoisted_440, [
                                            _withDirectives(_createVNode("input", {
                                              class: "form-check-input",
                                              type: "checkbox",
                                              id: "inlineCheckbox2",
                                              value: "true",
                                              "onUpdate:modelValue": ($event: any) => (invite.smsNotification = $event)
                                            }, null, 8, ["onUpdate:modelValue"]), [
                                              [_vModelCheckbox, invite.smsNotification]
                                            ]),
                                            _createVNode("label", _hoisted_441, _toDisplayString(_ctx.$t('sms')), 1)
                                          ])
                                        ])
                                      ])
                                    ]),
                                    _createVNode("td", null, [
                                      (_ctx.state.data.invite.invites.length === inviteIndex + 1)
                                        ? (_openBlock(), _createBlock("button", {
                                            key: 0,
                                            type: "button",
                                            class: "btn btn-sm text-primary mr-1",
                                            disabled: !_ctx.hasValidLastContact,
                                            onClick: _cache[90] || (_cache[90] = 
//@ts-ignore
(...args) => (_ctx.addNewMember && _ctx.addNewMember(...args)))
                                          }, [
                                            _hoisted_442,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('add')), 1)
                                          ], 8, ["disabled"]))
                                        : _createCommentVNode("", true),
                                      (_ctx.state.data.invite.invites.length != 1)
                                        ? (_openBlock(), _createBlock("a", {
                                            key: 1,
                                            class: "btn btn-sm red-btn mt-1 to-upper",
                                            href: "javascript:void(0)",
                                            disabled: _ctx.state.data.invite.invites.length === 1,
                                            onClick: ($event: any) => (_ctx.removeSelectedUser(invite))
                                          }, [
                                            _hoisted_443,
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('delete')), 1)
                                          ], 8, ["disabled", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_444, [
              _createVNode("div", null, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn secondary-btn mr-2  to-upper",
                  onClick: _cache[91] || (_cache[91] = 
//@ts-ignore
(...args) => (_ctx.hidePrivateChannel && _ctx.hidePrivateChannel(...args)))
                }, _toDisplayString(_ctx.$t('cancel')), 1),
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[92] || (_cache[92] = 
//@ts-ignore
(...args) => (_ctx.createPrivateChannelGroup && _ctx.createPrivateChannelGroup(...args)))
                }, _toDisplayString(_ctx.$t('make_private_channel')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_445, [
      _createVNode("div", _hoisted_446, [
        _createVNode("div", _hoisted_447, [
          _createVNode("div", _hoisted_448, [
            _createVNode("div", _hoisted_449, [
              _createVNode("h5", _hoisted_450, _toDisplayString(_ctx.$t('change_role')), 1),
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[93] || (_cache[93] = 
//@ts-ignore
(...args) => (_ctx.hideUserProfile && _ctx.hideUserProfile(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_451
              ])
            ]),
            _createVNode("div", _hoisted_452, [
              _createVNode("div", _hoisted_453, [
                (_ctx.state.data.selectedMember)
                  ? (_openBlock(), _createBlock("div", _hoisted_454, [
                      _createVNode("img", {
                        src: _ctx.state.data.selectedMember.image,
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_455, [
                      _hoisted_456
                    ])),
                (_ctx.state.data.selectedMember &&
                  _ctx.state.data.selectedMember.full_name
                )
                  ? (_openBlock(), _createBlock("h5", _hoisted_457, _toDisplayString(_ctx.state.data.selectedMember.full_name), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.data.selectedMember)
                  ? (_openBlock(), _createBlock("p", _hoisted_458, [
                      _hoisted_459,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.selectedMember.email), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_460, [
                (_ctx.state.data.selectedMember.added_at &&
                  _ctx.state.data.selectedMember.added_by
                )
                  ? (_openBlock(), _createBlock("p", _hoisted_461, _toDisplayString(_ctx.$t('added_by')) + " " + _toDisplayString(_ctx.state.data.selectedMember.added_by) + " " + _toDisplayString(_ctx.$t('on')) + " " + _toDisplayString(_ctx.state.data.selectedMember.added_at), 1))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_462, [
                  _createVNode("label", _hoisted_463, _toDisplayString(_ctx.$t('role')), 1),
                  _withDirectives(_createVNode("select", {
                    class: "form-control custom-select",
                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => (_ctx.state.data.selectedMemberRole = $event)),
                    onChange: _cache[95] || (_cache[95] = 
//@ts-ignore
(...args) => (_ctx.selectRole && _ctx.selectRole(...args)))
                  }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.roleList, (role, roleIndex) => {
                      return (_openBlock(), _createBlock("option", {
                        value: role.code,
                        key: roleIndex
                      }, _toDisplayString(role.name), 9, ["value"]))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.state.data.selectedMemberRole]
                  ])
                ]),
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.errors.roleError.errorList,
                  hasError: _ctx.state.ui.errors.roleError.hasError
                }, null, 8, ["errors", "hasError"]),
                (_ctx.state.data.selectedMemberRole === 'co-owner' || _ctx.state.data.selectedMemberRole === 'user')
                  ? (_openBlock(), _createBlock("div", _hoisted_464, [
                      _createVNode("label", _hoisted_465, [
                        _createTextVNode(_toDisplayString(_ctx.$t('channel_list')) + " ", 1),
                        _hoisted_466
                      ]),
                      _hoisted_467,
                      _createVNode("div", _hoisted_468, [
                        _createVNode("ul", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.allCreatedChannel, (channel, channelIndex) => {
                            return (_openBlock(), _createBlock("li", { key: channelIndex }, [
                              _createVNode("div", _hoisted_469, [
                                _withDirectives(_createVNode("input", {
                                  id: 'customCheck1' + channelIndex,
                                  class: "custom-control-input",
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => (channel.isChecked = $event),
                                  value: channel.id,
                                  onClick: ($event: any) => (_ctx.changeChannelCheckBox(channel))
                                }, null, 8, ["id", "onUpdate:modelValue", "value", "onClick"]), [
                                  [_vModelCheckbox, channel.isChecked]
                                ]),
                                _createVNode("label", {
                                  class: "custom-control-label",
                                  for: 'customCheck1' + channelIndex
                                }, _toDisplayString(channel.name), 9, ["for"])
                              ])
                            ]))
                          }), 128))
                        ]),
                        (_ctx.state.data.selectedMemberRole === 'co-owner')
                          ? (_openBlock(), _createBlock("div", _hoisted_470, [
                              _hoisted_471
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.state.data.selectedMemberRole === 'guest_user')
                  ? (_openBlock(), _createBlock("div", _hoisted_472, [
                      _createVNode("label", _hoisted_473, _toDisplayString(_ctx.$t('validity')), 1),
                      _createVNode(_component_v_date_picker, {
                        class: "inline-block h-full",
                        modelValue: _ctx.state.data.selectedValidityDate,
                        "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => (_ctx.state.data.selectedValidityDate = $event))
                      }, {
                        default: _withId(({ inputValue, togglePopover }) => [
                          _createVNode("div", _hoisted_474, [
                            _createVNode("button", {
                              class: "bg-green p-2",
                              onClick: ($event: any) => (togglePopover())
                            }, [
                              _hoisted_475
                            ], 8, ["onClick"]),
                            _createVNode("input", {
                              value: inputValue,
                              class: "form-control",
                              readonly: ""
                            }, null, 8, ["value"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_476, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[97] || (_cache[97] = 
//@ts-ignore
(...args) => (_ctx.saveProjectRole && _ctx.saveProjectRole(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.changeProjectRole
                  ? _ctx.$t('changing')
                  : _ctx.$t('save_changes')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_477, [
      _createVNode("div", _hoisted_478, [
        _createVNode("div", _hoisted_479, [
          _createVNode("div", _hoisted_480, [
            _createVNode("div", _hoisted_481, [
              _hoisted_482,
              _createVNode("button", {
                type: "button",
                class: "close",
                "data-dismiss": "modal",
                onClick: _cache[98] || (_cache[98] = 
//@ts-ignore
(...args) => (_ctx.hideUserProfile && _ctx.hideUserProfile(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_483
              ])
            ]),
            _createVNode("div", _hoisted_484, [
              _createVNode("div", _hoisted_485, [
                (_ctx.state.data.selectedMemberDetails)
                  ? (_openBlock(), _createBlock("div", _hoisted_486, [
                      _createVNode("img", {
                        src: _ctx.state.data.selectedMemberDetails?.image,
                        alt: ""
                      }, null, 8, ["src"])
                    ]))
                  : (_openBlock(), _createBlock("div", _hoisted_487, [
                      _hoisted_488
                    ])),
                (_ctx.state.data.selectedMemberDetails &&
                  _ctx.state.data.selectedMemberDetails.full_name
                )
                  ? (_openBlock(), _createBlock("h5", _hoisted_489, _toDisplayString(_ctx.state.data.selectedMemberDetails.full_name), 1))
                  : _createCommentVNode("", true),
                (_ctx.state.data.selectedMemberDetails)
                  ? (_openBlock(), _createBlock("p", _hoisted_490, [
                      _hoisted_491,
                      _createTextVNode(" " + _toDisplayString(_ctx.state.data.selectedMemberDetails.email), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode("div", _hoisted_492, [
                _createVNode(_component_ErrorList, {
                  errors: _ctx.state.ui.errors.roleError.errorList,
                  hasError: _ctx.state.ui.errors.roleError.hasError
                }, null, 8, ["errors", "hasError"]),
                _createVNode("div", _hoisted_493, [
                  _createVNode("label", _hoisted_494, [
                    _createTextVNode(_toDisplayString(_ctx.$t('channel_list')) + " ", 1),
                    _hoisted_495
                  ]),
                  _hoisted_496,
                  _createVNode("div", _hoisted_497, [
                    _createVNode("ul", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.memberChannelList, (channel, channelIndex) => {
                        return (_openBlock(), _createBlock("li", { key: channelIndex }, [
                          _createVNode("div", _hoisted_498, [
                            _withDirectives(_createVNode("input", {
                              id: 'customCheck1' + channelIndex,
                              class: "custom-control-input",
                              type: "checkbox",
                              "onUpdate:modelValue": ($event: any) => (channel.isChecked = $event),
                              value: channel.id,
                              onClick: ($event: any) => (_ctx.changeChannelCheckBox(channel))
                            }, null, 8, ["id", "onUpdate:modelValue", "value", "onClick"]), [
                              [_vModelCheckbox, channel.isChecked]
                            ]),
                            _createVNode("label", {
                              class: "custom-control-label",
                              for: 'customCheck1' + channelIndex
                            }, _toDisplayString(channel.name), 9, ["for"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_499, [
                _createVNode("a", {
                  href: "javascript:void(0)",
                  class: "btn default-btn",
                  onClick: _cache[99] || (_cache[99] = 
//@ts-ignore
(...args) => (_ctx.removeChannel && _ctx.removeChannel(...args)))
                }, _toDisplayString(_ctx.state.ui.isPostLoading.changeProjectRole
                  ? _ctx.$t('removing')
                  : _ctx.$t('remove')), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_500, [
      _createVNode("div", _hoisted_501, [
        _createVNode("div", _hoisted_502, [
          (_ctx.state.data.selectedMemberForRemoval)
            ? (_openBlock(), _createBlock("div", _hoisted_503, [
                _createVNode("div", _hoisted_504, [
                  (_ctx.state.data.selectedMemberForRemoval &&
                _ctx.state.data.selectedMemberForRemoval.full_name
              )
                    ? (_openBlock(), _createBlock("h5", _hoisted_505, _toDisplayString(_ctx.$t('remove')) + " " + _toDisplayString(_ctx.state.data.selectedMemberForRemoval.full_name) + " ? ", 1))
                    : _createCommentVNode("", true),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "aria-label": "Close",
                    onClick: _cache[100] || (_cache[100] = 
//@ts-ignore
(...args) => (_ctx.hideProjectMemberRemove && _ctx.hideProjectMemberRemove(...args)))
                  }, [
                    _hoisted_506
                  ])
                ]),
                _createVNode("div", _hoisted_507, [
                  _createVNode(_component_ErrorList, {
                    errors: _ctx.state.ui.errors.errorList.removeProjectRole,
                    hasError: _ctx.state.ui.errors.hasError
                  }, null, 8, ["errors", "hasError"]),
                  _createVNode("p", null, [
                    _createVNode("strong", null, _toDisplayString(_ctx.$t('removing_user_notice')) + ":", 1)
                  ]),
                  _createVNode("div", _hoisted_508, [
                    _createVNode("ul", null, [
                      (_ctx.state.data.selectedMemberForRemoval &&
                    _ctx.state.data.selectedMemberForRemoval.full_name
                  )
                        ? (_openBlock(), _createBlock("li", _hoisted_509, _toDisplayString(_ctx.state.data.selectedMemberForRemoval.full_name) + " " + _toDisplayString(_ctx.$t('will_be_removed_them_from_this_project')), 1))
                        : _createCommentVNode("", true),
                      (_ctx.state.data.selectedMemberForRemoval &&
                    _ctx.state.data.selectedMemberForRemoval.full_name
                  )
                        ? (_openBlock(), _createBlock("li", _hoisted_510, _toDisplayString(_ctx.state.data.selectedMemberForRemoval.full_name) + " " + _toDisplayString(_ctx.$t('user_no_activity')), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_511, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn to-upper",
                    onClick: _cache[101] || (_cache[101] = 
//@ts-ignore
(...args) => (_ctx.hideProjectMemberRemove && _ctx.hideProjectMemberRemove(...args)))
                  }, _toDisplayString(_ctx.$t('cancel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[102] || (_cache[102] = 
//@ts-ignore
(...args) => (_ctx.removeProjectRole && _ctx.removeProjectRole(...args)))
                  }, _toDisplayString(_ctx.state.postLoading.removeProjectRole
                ? _ctx.$t('removing')
                : _ctx.$t('yes_remove_user')), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_ctx.state.data.showChannelModal)
      ? (_openBlock(), _createBlock("div", _hoisted_512, [
          _createVNode("div", _hoisted_513, [
            _createVNode("div", _hoisted_514, [
              _createVNode("div", _hoisted_515, [
                _createVNode("div", _hoisted_516, [
                  _createVNode("h5", _hoisted_517, _toDisplayString(_ctx.$t('unhide_channel')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "close",
                    "data-dismiss": "modal",
                    onClick: _cache[103] || (_cache[103] = 
//@ts-ignore
(...args) => (_ctx.showChannelClose && _ctx.showChannelClose(...args))),
                    "aria-label": "Close"
                  }, [
                    _hoisted_518
                  ])
                ]),
                _createVNode("div", _hoisted_519, [
                  _createVNode("div", _hoisted_520, _toDisplayString(_ctx.$t('unhide_confirmation')), 1)
                ]),
                _createVNode("div", _hoisted_521, [
                  _createVNode("button", {
                    type: "button",
                    class: "btn default-btn",
                    onClick: _cache[104] || (_cache[104] = 
//@ts-ignore
(...args) => (_ctx.channelShow && _ctx.channelShow(...args)))
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.channelShow ? _ctx.$t('loading1') : _ctx.$t('yes')), 1),
                  _createVNode("button", {
                    type: "button",
                    class: "btn secondary-btn",
                    "data-dismiss": "modal",
                    onClick: _cache[105] || (_cache[105] = 
//@ts-ignore
(...args) => (_ctx.showChannelClose && _ctx.showChannelClose(...args)))
                  }, _toDisplayString(_ctx.$t('no')), 1)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 1,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage,
          subTitleMessage: _ctx.state.data.subTitleMessage,
          isButton: _ctx.state.data.isChannelCreated
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_522, [
              _createVNode("button", {
                type: "button",
                class: "btn default-btn mr-2 mb-2",
                onClick: _cache[106] || (_cache[106] = ($event: any) => (_ctx.addMember(_ctx.state.data.currentChannel)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$t('continue_to_invite_members')) + " ", 1),
                _hoisted_523
              ])
            ])
          ]),
          _: 1
        }, 8, ["onClose", "showModal", "titleMessage", "subTitleMessage", "isButton"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showProjectImageUploadModal)
      ? (_openBlock(), _createBlock(_component_ProjectImageUploadModal, {
          key: 2,
          onClose: _ctx.closeProjectImageUploadModal,
          showModal: _ctx.state.data.showProjectImageUploadModal,
          project: _ctx.state.data.projectDetail.project
        }, null, 8, ["onClose", "showModal", "project"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showMemberListModal)
      ? (_openBlock(), _createBlock(_component_ShowMemberListModal, {
          key: 3,
          showModal: _ctx.state.data.showMemberListModal,
          members: _ctx.state.data.memberList,
          projectRoleCodes: _ctx.state.data.projectRole,
          onClose: _ctx.hideMemberListModal
        }, null, 8, ["showModal", "members", "projectRoleCodes", "onClose"]))
      : _createCommentVNode("", true)
  ]))
})